import { coreTables, localizeMap, parseOperatorTables, localizeLoloSource, localizeOrbValue } from '@almadar/core/i18n';

// src/tokens.json
var tokens_default = {
  operatorsByNamespace: {
    arithmetic: [
      "prob/credible-interval",
      "prob/expected-value",
      "prob/categorical",
      "prob/percentile",
      "math/randomInt",
      "prob/condition",
      "prob/posterior",
      "prob/histogram",
      "math/approach",
      "prob/gaussian",
      "prob/variance",
      "math/default",
      "math/deg-rad",
      "math/rad-deg",
      "prob/uniform",
      "prob/poisson",
      "math/random",
      "prob/sample",
      "math/clamp",
      "math/floor",
      "math/round",
      "math/atan2",
      "math/hypot",
      "prob/infer",
      "math/ceil",
      "math/sqrt",
      "math/sign",
      "math/lerp",
      "math/asin",
      "math/acos",
      "math/atan",
      "math/wrap",
      "prob/seed",
      "prob/flip",
      "prob/beta",
      "math/abs",
      "math/min",
      "math/max",
      "math/pow",
      "math/mod",
      "math/map",
      "math/sin",
      "math/cos",
      "math/tan",
      "+",
      "-",
      "*",
      "/",
      "%"
    ],
    comparison: [
      "validate/creditCard",
      "validate/minLength",
      "validate/maxLength",
      "validate/required",
      "validate/boolean",
      "validate/pattern",
      "validate/string",
      "validate/number",
      "validate/object",
      "validate/length",
      "validate/noneOf",
      "validate/equals",
      "validate/array",
      "validate/email",
      "validate/phone",
      "validate/range",
      "validate/oneOf",
      "validate/check",
      "validate/uuid",
      "validate/date",
      "validate/url",
      "validate/min",
      "validate/max",
      "==",
      "!=",
      "<=",
      ">=",
      "=",
      "<",
      ">"
    ],
    logic: [
      "and",
      "not",
      "or",
      "if"
    ],
    control: [
      "list",
      "when",
      "let",
      "do",
      "fn"
    ],
    effect: [
      "navigate-back",
      "fetch-stream",
      "call-service",
      "send-server",
      "render-ui",
      "navigate",
      "persist",
      "despawn",
      "notify",
      "spawn",
      "fetch",
      "emit",
      "set",
      "log",
      "ref"
    ],
    string: [
      "format/creditCard",
      "format/currency",
      "str/replaceAll",
      "str/startsWith",
      "str/capitalize",
      "format/percent",
      "format/ordinal",
      "str/trimStart",
      "str/titleCase",
      "str/camelCase",
      "str/kebabCase",
      "str/snakeCase",
      "format/number",
      "format/plural",
      "str/includes",
      "str/endsWith",
      "str/padStart",
      "str/template",
      "str/truncate",
      "format/bytes",
      "format/phone",
      "str/trimEnd",
      "str/replace",
      "str/reverse",
      "str/default",
      "format/list",
      "str/concat",
      "str/padEnd",
      "str/repeat",
      "str/upper",
      "str/lower",
      "str/split",
      "str/slice",
      "str/trim",
      "str/join",
      "str/len"
    ],
    collection: [
      "object/fromEntries",
      "array/removeItem",
      "object/deepMerge",
      "object/mapValues",
      "object/deepClone",
      "array/findIndex",
      "array/partition",
      "array/includes",
      "array/takeLast",
      "array/dropLast",
      "object/entries",
      "object/mapKeys",
      "array/prepend",
      "array/reverse",
      "array/shuffle",
      "array/flatten",
      "array/indexOf",
      "array/groupBy",
      "array/nearest",
      "object/values",
      "object/filter",
      "object/equals",
      "array/concat",
      "array/append",
      "array/insert",
      "array/remove",
      "array/unique",
      "array/filter",
      "array/reject",
      "array/reduce",
      "array/cosine",
      "object/merge",
      "object/clone",
      "array/range",
      "array/first",
      "array/slice",
      "array/every",
      "array/count",
      "object/keys",
      "object/pick",
      "object/omit",
      "array/last",
      "array/sort",
      "array/find",
      "array/some",
      "array/take",
      "array/drop",
      "object/get",
      "object/set",
      "object/has",
      "array/len",
      "array/nth",
      "array/zip",
      "array/map",
      "array/sum",
      "array/avg",
      "array/min",
      "array/max",
      "path"
    ],
    "std-time": [
      "time/isBetween",
      "time/subtract",
      "time/isBefore",
      "time/isFuture",
      "time/relative",
      "time/duration",
      "time/weekday",
      "time/startOf",
      "time/isAfter",
      "time/isToday",
      "time/format",
      "time/minute",
      "time/second",
      "time/isSame",
      "time/isPast",
      "time/today",
      "time/parse",
      "time/month",
      "time/endOf",
      "time/year",
      "time/hour",
      "time/diff",
      "time/now",
      "time/day",
      "time/add"
    ],
    "std-async": [
      "async/interval",
      "async/debounce",
      "async/throttle",
      "async/sequence",
      "async/timeout",
      "async/delay",
      "async/retry",
      "async/race",
      "async/all"
    ],
    "ml-arch": [
      "nn/sequential",
      "nn/getWeights",
      "nn/setWeights",
      "nn/paramCount",
      "nn/batchnorm",
      "nn/layernorm",
      "nn/sigmoid",
      "nn/softmax",
      "nn/dropout",
      "nn/linear",
      "nn/clone",
      "nn/relu",
      "nn/tanh"
    ],
    "ml-effect": [
      "train/checkForbiddenOutputs",
      "train/getMaxWeightMagnitude",
      "train/checkWeightMagnitude",
      "train/computeAdvantages",
      "train/checkConstraints",
      "train/checkRegression",
      "train/getGradientNorm",
      "train/computeReturns",
      "train/clipGradients",
      "train/crossEntropy",
      "train/clipWeights",
      "train/sampleBatch",
      "checkpoint/save",
      "checkpoint/load",
      "train/validate",
      "train/huber",
      "nn/forward",
      "train/loop",
      "train/step",
      "train/adam",
      "train/mse",
      "train/sgd",
      "evaluate",
      "forward",
      "train"
    ],
    "ml-tensor": [
      "tensor/outOfRangeIndices",
      "tensor/outOfRangeDims",
      "tensor/clampPerDim",
      "tensor/allInRange",
      "tensor/transpose",
      "tensor/unsqueeze",
      "tensor/reshape",
      "tensor/flatten",
      "tensor/toArray",
      "tensor/squeeze",
      "tensor/matmul",
      "tensor/argmax",
      "tensor/toList",
      "tensor/zeros",
      "tensor/randn",
      "tensor/shape",
      "tensor/slice",
      "tensor/clamp",
      "tensor/stack",
      "tensor/from",
      "tensor/ones",
      "tensor/rand",
      "tensor/mean",
      "tensor/norm",
      "tensor/get",
      "tensor/add",
      "tensor/sub",
      "tensor/mul",
      "tensor/div",
      "tensor/dot",
      "tensor/sum",
      "tensor/max",
      "tensor/min",
      "tensor/cat"
    ],
    "ml-graph": [
      "graph/from-adjacency",
      "graph/from-edge-list",
      "graph/add-self-loops",
      "graph/from-entities",
      "graph/to-undirected",
      "graph/node-features",
      "graph/edge-features",
      "graph/edge-index",
      "graph/num-nodes",
      "graph/num-edges",
      "graph/subgraph",
      "graph/degree",
      "graph/k-hop",
      "graph/batch"
    ],
    "ml-contract": [
      "contract/tensor-to-payload",
      "contract/entity-to-tensor",
      "contract/validate-output",
      "contract/validate-input",
      "contract/clamp-output",
      "contract/violations"
    ],
    "ml-data": [
      "data/dataloader",
      "data/normalize",
      "data/tokenize",
      "data/dataset",
      "data/augment",
      "data/split",
      "data/pad"
    ],
    "std-os": [
      "os/watch-process",
      "os/watch-signal",
      "os/watch-files",
      "os/watch-port",
      "os/watch-http",
      "os/watch-cron",
      "os/watch-env",
      "os/debounce"
    ],
    "std-browser": [
      "browser/geolocation-current",
      "browser/open-file-picker",
      "browser/clipboard-write",
      "browser/clipboard-read",
      "browser/push-subscribe"
    ],
    "std-composition": [
      "behavior/detect-layout",
      "behavior/compose",
      "behavior/wire",
      "behavior/pipe"
    ],
    "std-vec": [
      "vec/clamp-length",
      "vec/distance-sq",
      "vec/length-sq",
      "vec/normalize",
      "vec/distance",
      "vec/length",
      "vec/rotate",
      "vec/scale",
      "vec/cross",
      "vec/angle",
      "vec/lerp",
      "vec/add",
      "vec/sub",
      "vec/dot"
    ],
    "std-geo": [
      "geo/rect-circle-overlap",
      "geo/segment-intersect",
      "geo/point-in-circle",
      "geo/circle-overlap",
      "geo/point-in-rect",
      "geo/aabb-overlap",
      "geo/reflect"
    ],
    "std-grid": [
      "grid/manhattan-distance",
      "grid/cells-in-radius",
      "grid/iso-to-screen",
      "grid/screen-to-iso",
      "grid/from-world",
      "grid/neighbors",
      "grid/in-bounds",
      "grid/to-world",
      "grid/distance",
      "grid/line"
    ],
    "std-anim": [
      "anim/direction-from-delta",
      "anim/sheet-rect",
      "anim/frame-at"
    ],
    "std-ease": [
      "ease/smoothstep",
      "ease/apply"
    ],
    "std-noise": [
      "noise/simplex",
      "noise/perlin",
      "noise/fbm"
    ],
    "std-path": [
      "path/reachable",
      "path/astar"
    ],
    "std-llm": [
      "llm/token-count",
      "llm/call-tools",
      "llm/generate",
      "llm/compact",
      "llm/switch",
      "llm/embed"
    ],
    "std-workspace": [
      "workspace/archive-orbital",
      "workspace/write-orbital",
      "workspace/list-orbitals",
      "workspace/read-orbital",
      "workspace/write-schema",
      "workspace/read-schema",
      "workspace/write-file",
      "workspace/write-plan",
      "workspace/read-file",
      "workspace/read-plan",
      "workspace/exists"
    ],
    "std-session": [
      "session/append-history",
      "session/read-analysis",
      "session/write-memory",
      "session/read-history",
      "session/write-errors",
      "session/read-memory",
      "session/read-errors",
      "session/write-spec",
      "session/read-spec"
    ],
    "std-memory": [
      "memory/recall",
      "memory/store",
      "memory/list"
    ],
    "std-trace": [
      "trace/emit",
      "trace/log"
    ],
    "std-behavior": [
      "compose/compose-children",
      "behavior/instantiate",
      "compose/compose-all",
      "validate/validate",
      "lolo/emit-body",
      "behavior/call"
    ],
    "std-integration": [
      "integration/github-create-issue",
      "integration/github-get-repo",
      "integration/http"
    ]
  },
  allOperatorNames: [
    "+",
    "-",
    "*",
    "/",
    "%",
    "=",
    "==",
    "!=",
    "<",
    ">",
    "<=",
    ">=",
    "and",
    "or",
    "not",
    "if",
    "let",
    "do",
    "list",
    "when",
    "fn",
    "set",
    "emit",
    "persist",
    "navigate",
    "navigate-back",
    "notify",
    "log",
    "spawn",
    "despawn",
    "fetch",
    "fetch-stream",
    "send-server",
    "ref",
    "call-service",
    "render-ui",
    "math/abs",
    "math/min",
    "math/max",
    "math/clamp",
    "math/floor",
    "math/ceil",
    "math/round",
    "math/pow",
    "math/sqrt",
    "math/mod",
    "math/sign",
    "math/lerp",
    "math/map",
    "math/random",
    "math/randomInt",
    "math/default",
    "math/sin",
    "math/cos",
    "math/tan",
    "math/atan2",
    "math/asin",
    "math/acos",
    "math/atan",
    "math/hypot",
    "math/deg-rad",
    "math/rad-deg",
    "math/wrap",
    "math/approach",
    "str/len",
    "str/concat",
    "str/upper",
    "str/lower",
    "str/trim",
    "str/trimStart",
    "str/trimEnd",
    "str/split",
    "str/join",
    "str/slice",
    "str/replace",
    "str/replaceAll",
    "str/includes",
    "str/startsWith",
    "str/endsWith",
    "str/padStart",
    "str/padEnd",
    "str/repeat",
    "str/reverse",
    "str/capitalize",
    "str/titleCase",
    "str/camelCase",
    "str/kebabCase",
    "str/snakeCase",
    "str/default",
    "str/template",
    "str/truncate",
    "array/len",
    "array/range",
    "array/first",
    "array/last",
    "array/nth",
    "array/slice",
    "array/concat",
    "array/append",
    "array/prepend",
    "array/insert",
    "array/remove",
    "array/removeItem",
    "array/reverse",
    "array/sort",
    "array/shuffle",
    "array/unique",
    "array/flatten",
    "array/zip",
    "array/includes",
    "array/indexOf",
    "array/find",
    "array/findIndex",
    "array/filter",
    "array/reject",
    "array/map",
    "array/reduce",
    "array/every",
    "array/some",
    "array/count",
    "array/sum",
    "array/avg",
    "array/min",
    "array/max",
    "array/groupBy",
    "array/partition",
    "array/take",
    "array/drop",
    "array/takeLast",
    "array/dropLast",
    "array/cosine",
    "array/nearest",
    "object/keys",
    "object/values",
    "object/entries",
    "object/fromEntries",
    "object/get",
    "object/set",
    "object/has",
    "object/merge",
    "object/deepMerge",
    "object/pick",
    "object/omit",
    "object/mapValues",
    "object/mapKeys",
    "object/filter",
    "object/equals",
    "object/clone",
    "object/deepClone",
    "path",
    "time/now",
    "time/today",
    "time/parse",
    "time/format",
    "time/year",
    "time/month",
    "time/day",
    "time/weekday",
    "time/hour",
    "time/minute",
    "time/second",
    "time/add",
    "time/subtract",
    "time/diff",
    "time/startOf",
    "time/endOf",
    "time/isBefore",
    "time/isAfter",
    "time/isBetween",
    "time/isSame",
    "time/isPast",
    "time/isFuture",
    "time/isToday",
    "time/relative",
    "time/duration",
    "validate/required",
    "validate/string",
    "validate/number",
    "validate/boolean",
    "validate/array",
    "validate/object",
    "validate/email",
    "validate/url",
    "validate/uuid",
    "validate/phone",
    "validate/creditCard",
    "validate/date",
    "validate/minLength",
    "validate/maxLength",
    "validate/length",
    "validate/min",
    "validate/max",
    "validate/range",
    "validate/pattern",
    "validate/oneOf",
    "validate/noneOf",
    "validate/equals",
    "validate/check",
    "format/number",
    "format/currency",
    "format/percent",
    "format/bytes",
    "format/ordinal",
    "format/plural",
    "format/list",
    "format/phone",
    "format/creditCard",
    "async/delay",
    "async/interval",
    "async/timeout",
    "async/debounce",
    "async/throttle",
    "async/retry",
    "async/race",
    "async/all",
    "async/sequence",
    "nn/sequential",
    "nn/linear",
    "nn/relu",
    "nn/tanh",
    "nn/sigmoid",
    "nn/softmax",
    "nn/dropout",
    "nn/batchnorm",
    "nn/layernorm",
    "nn/forward",
    "nn/getWeights",
    "nn/setWeights",
    "nn/paramCount",
    "nn/clone",
    "forward",
    "tensor/from",
    "tensor/zeros",
    "tensor/ones",
    "tensor/rand",
    "tensor/randn",
    "tensor/shape",
    "tensor/get",
    "tensor/slice",
    "tensor/reshape",
    "tensor/flatten",
    "tensor/add",
    "tensor/sub",
    "tensor/mul",
    "tensor/div",
    "tensor/matmul",
    "tensor/dot",
    "tensor/sum",
    "tensor/mean",
    "tensor/max",
    "tensor/min",
    "tensor/argmax",
    "tensor/norm",
    "tensor/allInRange",
    "tensor/outOfRangeIndices",
    "tensor/clamp",
    "tensor/clampPerDim",
    "tensor/outOfRangeDims",
    "tensor/toArray",
    "tensor/toList",
    "tensor/cat",
    "tensor/stack",
    "tensor/transpose",
    "tensor/unsqueeze",
    "tensor/squeeze",
    "train/loop",
    "train/step",
    "train/validate",
    "train/checkRegression",
    "train/checkConstraints",
    "train/checkWeightMagnitude",
    "train/checkForbiddenOutputs",
    "train/clipGradients",
    "train/getGradientNorm",
    "train/clipWeights",
    "train/getMaxWeightMagnitude",
    "train/mse",
    "train/crossEntropy",
    "train/huber",
    "train/sgd",
    "train/adam",
    "train/sampleBatch",
    "train/computeReturns",
    "train/computeAdvantages",
    "train",
    "evaluate",
    "checkpoint/save",
    "checkpoint/load",
    "graph/from-entities",
    "graph/from-adjacency",
    "graph/from-edge-list",
    "graph/add-self-loops",
    "graph/to-undirected",
    "graph/subgraph",
    "graph/k-hop",
    "graph/node-features",
    "graph/edge-index",
    "graph/edge-features",
    "graph/num-nodes",
    "graph/num-edges",
    "graph/degree",
    "graph/batch",
    "contract/validate-input",
    "contract/validate-output",
    "contract/clamp-output",
    "contract/violations",
    "contract/entity-to-tensor",
    "contract/tensor-to-payload",
    "data/dataset",
    "data/dataloader",
    "data/split",
    "data/normalize",
    "data/augment",
    "data/tokenize",
    "data/pad",
    "prob/seed",
    "prob/flip",
    "prob/gaussian",
    "prob/uniform",
    "prob/beta",
    "prob/categorical",
    "prob/poisson",
    "prob/condition",
    "prob/sample",
    "prob/posterior",
    "prob/infer",
    "prob/expected-value",
    "prob/variance",
    "prob/histogram",
    "prob/percentile",
    "prob/credible-interval",
    "os/watch-files",
    "os/watch-process",
    "os/watch-port",
    "os/watch-http",
    "os/watch-cron",
    "os/watch-signal",
    "os/watch-env",
    "os/debounce",
    "browser/open-file-picker",
    "browser/clipboard-read",
    "browser/clipboard-write",
    "browser/push-subscribe",
    "browser/geolocation-current",
    "behavior/compose",
    "behavior/wire",
    "behavior/detect-layout",
    "behavior/pipe",
    "vec/add",
    "vec/sub",
    "vec/scale",
    "vec/dot",
    "vec/cross",
    "vec/length",
    "vec/length-sq",
    "vec/normalize",
    "vec/distance",
    "vec/distance-sq",
    "vec/lerp",
    "vec/angle",
    "vec/rotate",
    "vec/clamp-length",
    "geo/aabb-overlap",
    "geo/circle-overlap",
    "geo/rect-circle-overlap",
    "geo/point-in-rect",
    "geo/point-in-circle",
    "geo/reflect",
    "geo/segment-intersect",
    "grid/to-world",
    "grid/from-world",
    "grid/iso-to-screen",
    "grid/screen-to-iso",
    "grid/distance",
    "grid/manhattan-distance",
    "grid/neighbors",
    "grid/cells-in-radius",
    "grid/line",
    "grid/in-bounds",
    "anim/frame-at",
    "anim/sheet-rect",
    "anim/direction-from-delta",
    "ease/apply",
    "ease/smoothstep",
    "noise/perlin",
    "noise/simplex",
    "noise/fbm",
    "path/astar",
    "path/reachable",
    "llm/generate",
    "llm/call-tools",
    "llm/embed",
    "llm/token-count",
    "llm/switch",
    "llm/compact",
    "workspace/read-orbital",
    "workspace/write-orbital",
    "workspace/read-file",
    "workspace/write-file",
    "workspace/exists",
    "workspace/list-orbitals",
    "workspace/read-schema",
    "workspace/write-schema",
    "workspace/read-plan",
    "workspace/write-plan",
    "workspace/archive-orbital",
    "session/read-spec",
    "session/write-spec",
    "session/read-memory",
    "session/write-memory",
    "session/read-history",
    "session/append-history",
    "session/read-errors",
    "session/write-errors",
    "session/read-analysis",
    "memory/recall",
    "memory/store",
    "memory/list",
    "trace/emit",
    "trace/log",
    "compose/compose-all",
    "compose/compose-children",
    "behavior/instantiate",
    "behavior/call",
    "lolo/emit-body",
    "validate/validate",
    "integration/http",
    "integration/github-get-repo",
    "integration/github-create-issue"
  ],
  patternNames: [
    "feature-detail-page-template",
    "infinite-scroll-sentinel",
    "repeatable-form-section",
    "branching-logic-builder",
    "option-constraint-group",
    "floating-action-button",
    "book-table-of-contents",
    "law-reference-tooltip",
    "orbital-visualization",
    "feature-grid-organism",
    "landing-page-template",
    "pricing-page-template",
    "generic-app-template",
    "jazari-state-machine",
    "master-detail-layout",
    "subagent-trace-panel",
    "import-source-picker",
    "conditional-wrapper",
    "form-section-header",
    "date-range-selector",
    "case-study-organism",
    "about-page-template",
    "marketing-stat-card",
    "import-preview-tree",
    "state-machine-view",
    "step-flow-organism",
    "wizard-navigation",
    "showcase-organism",
    "geometric-pattern",
    "positioned-canvas",
    "book-chapter-view",
    "game-audio-toggle",
    "date-range-picker",
    "code-runner-panel",
    "draw-sprite-layer",
    "algo-graph-canvas",
    "ui-slot-component",
    "wizard-container",
    "runtime-debugger",
    "counter-template",
    "dashboard-layout",
    "markdown-content",
    "content-renderer",
    "upload-drop-zone",
    "animated-counter",
    "pricing-organism",
    "animated-graphic",
    "ui-slot-renderer",
    "gradient-divider",
    "tabbed-container",
    "marketing-footer",
    "activation-block",
    "bloom-quiz-block",
    "connection-block",
    "reflection-block",
    "segment-renderer",
    "chemistry-canvas",
    "algorithm-canvas",
    "draw-shape-layer",
    "rich-text-editor",
    "document-details",
    "floating-toolbar",
    "wizard-progress",
    "relation-select",
    "violation-alert",
    "document-viewer",
    "trend-indicator",
    "confetti-effect",
    "typewriter-text",
    "pull-to-refresh",
    "content-section",
    "article-section",
    "case-study-card",
    "community-links",
    "service-catalog",
    "animated-reveal",
    "edge-decoration",
    "matrix-question",
    "dialogue-bubble",
    "book-cover-page",
    "learning-canvas",
    "state-json-view",
    "draw-text-layer",
    "page-transition",
    "import-progress",
    "command-palette",
    "confirm-dialog",
    "text-highlight",
    "error-boundary",
    "scaled-diagram",
    "flip-container",
    "time-slot-cell",
    "number-stepper",
    "section-header",
    "stats-organism",
    "control-button",
    "svg-connection",
    "doc-breadcrumb",
    "doc-pagination",
    "action-palette",
    "dashboard-grid",
    "biology-canvas",
    "physics-canvas",
    "document-panel",
    "game-audio-cue",
    "loading-state",
    "master-detail",
    "media-gallery",
    "signature-pad",
    "calendar-grid",
    "progress-dots",
    "sortable-list",
    "swipeable-row",
    "showcase-card",
    "split-section",
    "hero-organism",
    "team-organism",
    "choice-button",
    "score-display",
    "timer-display",
    "behavior-view",
    "draw-fx-layer",
    "entity-table",
    "entity-cards",
    "detail-panel",
    "form-section",
    "search-input",
    "filter-group",
    "notification",
    "progress-bar",
    "theme-toggle",
    "form-actions",
    "graph-canvas",
    "chart-legend",
    "range-slider",
    "stat-display",
    "feature-card",
    "feature-grid",
    "hero-section",
    "pricing-card",
    "pricing-grid",
    "social-proof",
    "pattern-tile",
    "likert-scale",
    "version-diff",
    "book-nav-bar",
    "sequence-bar",
    "control-grid",
    "emoji-picker",
    "entity-list",
    "page-header",
    "empty-state",
    "error-state",
    "simple-grid",
    "input-group",
    "drawer-slot",
    "auth-layout",
    "star-rating",
    "install-box",
    "trait-frame",
    "filter-pill",
    "doc-sidebar",
    "module-card",
    "book-viewer",
    "action-tile",
    "form-layout",
    "math-canvas",
    "state-graph",
    "atlas-image",
    "atlas-panel",
    "draw-sprite",
    "dock-layout",
    "breadcrumb",
    "pagination",
    "typography",
    "form-field",
    "side-panel",
    "modal-slot",
    "navigation",
    "toast-slot",
    "game-shell",
    "quiz-block",
    "code-block",
    "graph-view",
    "line-chart",
    "status-dot",
    "stats-grid",
    "cta-banner",
    "qr-scanner",
    "vote-stack",
    "reply-tree",
    "health-bar",
    "svg-branch",
    "svg-shield",
    "doc-search",
    "pull-quote",
    "stat-badge",
    "trait-slot",
    "split-pane",
    "table-view",
    "draw-shape",
    "draw-group",
    "fx-overlay",
    "accordion",
    "container",
    "flip-card",
    "data-grid",
    "data-list",
    "tag-cloud",
    "team-card",
    "file-tree",
    "svg-morph",
    "svg-pulse",
    "svg-stack",
    "game-menu",
    "sparkline",
    "tag-input",
    "step-flow",
    "stat-card",
    "canvas-2d",
    "game-icon",
    "draw-text",
    "draw-mesh",
    "textarea",
    "checkbox",
    "timeline",
    "skeleton",
    "day-cell",
    "map-view",
    "lightbox",
    "carousel",
    "svg-flow",
    "svg-grid",
    "svg-lobe",
    "svg-mesh",
    "svg-node",
    "svg-ring",
    "game-hud",
    "chat-bar",
    "presence",
    "divider",
    "spinner",
    "tooltip",
    "popover",
    "overlay",
    "section",
    "sidebar",
    "doc-toc",
    "drawer",
    "center",
    "spacer",
    "button",
    "avatar",
    "select",
    "switch",
    "header",
    "dialog",
    "vstack",
    "hstack",
    "canvas",
    "modal",
    "badge",
    "input",
    "radio",
    "label",
    "alert",
    "stack",
    "split",
    "chart",
    "meter",
    "aside",
    "form",
    "tabs",
    "grid",
    "icon",
    "card",
    "menu",
    "flex",
    "box"
  ],
  behaviorNames: [
    "std-agent-completion",
    "std-agent-context",
    "std-agent-fix-loop",
    "std-agent-memory",
    "std-agent-planner",
    "std-agent-session",
    "std-agent-tool-call",
    "std-agent-tool-loop",
    "std-agent-trace",
    "std-agent-builder",
    "std-agent-rabit",
    "std-anim-tick",
    "std-approval-gate",
    "std-audit-capture",
    "std-cache-aside",
    "std-calendar-sync",
    "std-cascade-on-delete",
    "std-circuit-breaker",
    "std-cooldown",
    "std-cross-reference",
    "std-data-erasure",
    "std-game-clock",
    "std-lifecycle",
    "std-migration-job",
    "std-mod-queue",
    "std-notification-center",
    "std-notify-on-event",
    "std-rate-limiter",
    "std-reminder-scheduler",
    "std-row-access-control",
    "std-status-lifecycle",
    "std-status-lifecycle-control",
    "std-data-collector",
    "std-graph-builder",
    "std-ml-classify",
    "std-ml-exact-check",
    "std-ml-infer",
    "std-ml-label-capture",
    "std-ml-lookup",
    "std-ml-posterior",
    "std-ml-similarity",
    "std-tokenizer",
    "std-weight-validator",
    "std-escalating-decision",
    "std-knowledge-tracing"
  ],
  structuralKeys: [
    "name",
    "description",
    "version",
    "orbitals",
    "entity",
    "traits",
    "pages",
    "stateMachine",
    "states",
    "events",
    "transitions",
    "fields",
    "emits",
    "listens",
    "persistence",
    "linkedEntity",
    "category",
    "collection",
    "uses",
    "expects",
    "services",
    "config",
    "theme",
    "design",
    "domainContext",
    "designTokens",
    "customPatterns"
  ],
  fieldTypes: [
    "string",
    "number",
    "boolean",
    "date",
    "timestamp",
    "datetime",
    "email",
    "url",
    "phone",
    "uuid",
    "image",
    "array",
    "object",
    "enum",
    "relation"
  ],
  persistenceKinds: [
    "persistent",
    "runtime"
  ],
  effectTypes: [
    "navigate-back",
    "fetch-stream",
    "call-service",
    "send-server",
    "render-ui",
    "navigate",
    "persist",
    "despawn",
    "notify",
    "spawn",
    "fetch",
    "emit",
    "set",
    "log",
    "ref"
  ],
  uiSlots: [
    "main",
    "sidebar",
    "modal",
    "drawer",
    "overlay",
    "center",
    "toast",
    "hud-top",
    "hud-bottom",
    "floating",
    "system",
    "content",
    "screen"
  ],
  loloKeywords: [
    "app",
    "orbital",
    "uses",
    "from",
    "expects",
    "entity",
    "type",
    "derived",
    "extends",
    "trait",
    "initial",
    "state",
    "for",
    "emits",
    "listens",
    "ticks",
    "config",
    "page",
    "with"
  ],
  loloPrimitiveTypes: [
    "string",
    "number",
    "boolean",
    "date",
    "timestamp",
    "datetime",
    "int",
    "email",
    "url",
    "phone",
    "uuid",
    "image"
  ],
  loloPersistenceAndScope: [
    "persistent",
    "runtime",
    "internal",
    "external"
  ],
  loloTraitCategories: [
    "interaction",
    "integration",
    "lifecycle",
    "temporal",
    "validation",
    "notification",
    "agent",
    "game-core",
    "game-character",
    "game-ai",
    "game-combat",
    "game-items",
    "game-cards",
    "game-board",
    "game-puzzle"
  ],
  i18nOperators: {
    en: {
      "!=": "!=",
      "%": "%",
      "*": "*",
      "+": "+",
      "-": "-",
      "/": "/",
      "<": "<",
      "<=": "<=",
      "=": "=",
      "==": "==",
      ">": ">",
      ">=": ">=",
      and: "and",
      "anim/direction-from-delta": "anim/direction-from-delta",
      "anim/frame-at": "anim/frame-at",
      "anim/sheet-rect": "anim/sheet-rect",
      "array/append": "array/append",
      "array/avg": "array/avg",
      "array/concat": "array/concat",
      "array/cosine": "array/cosine",
      "array/count": "array/count",
      "array/drop": "array/drop",
      "array/dropLast": "array/dropLast",
      "array/every": "array/every",
      "array/filter": "array/filter",
      "array/find": "array/find",
      "array/findIndex": "array/findIndex",
      "array/first": "array/first",
      "array/flatten": "array/flatten",
      "array/groupBy": "array/groupBy",
      "array/includes": "array/includes",
      "array/indexOf": "array/indexOf",
      "array/insert": "array/insert",
      "array/last": "array/last",
      "array/len": "array/len",
      "array/map": "array/map",
      "array/max": "array/max",
      "array/min": "array/min",
      "array/nearest": "array/nearest",
      "array/nth": "array/nth",
      "array/partition": "array/partition",
      "array/prepend": "array/prepend",
      "array/range": "array/range",
      "array/reduce": "array/reduce",
      "array/reject": "array/reject",
      "array/remove": "array/remove",
      "array/removeItem": "array/removeItem",
      "array/reverse": "array/reverse",
      "array/shuffle": "array/shuffle",
      "array/slice": "array/slice",
      "array/some": "array/some",
      "array/sort": "array/sort",
      "array/sum": "array/sum",
      "array/take": "array/take",
      "array/takeLast": "array/takeLast",
      "array/unique": "array/unique",
      "array/zip": "array/zip",
      "async/all": "async/all",
      "async/debounce": "async/debounce",
      "async/delay": "async/delay",
      "async/interval": "async/interval",
      "async/race": "async/race",
      "async/retry": "async/retry",
      "async/sequence": "async/sequence",
      "async/throttle": "async/throttle",
      "async/timeout": "async/timeout",
      "behavior/call": "behavior/call",
      "behavior/compose": "behavior/compose",
      "behavior/detect-layout": "behavior/detect-layout",
      "behavior/instantiate": "behavior/instantiate",
      "behavior/pipe": "behavior/pipe",
      "behavior/wire": "behavior/wire",
      "browser/clipboard-read": "browser/clipboard-read",
      "browser/clipboard-write": "browser/clipboard-write",
      "browser/geolocation-current": "browser/geolocation-current",
      "browser/open-file-picker": "browser/open-file-picker",
      "browser/push-subscribe": "browser/push-subscribe",
      "call-service": "call-service",
      "checkpoint/load": "checkpoint/load",
      "checkpoint/save": "checkpoint/save",
      "compose/compose-all": "compose/compose-all",
      "compose/compose-children": "compose/compose-children",
      "contract/clamp-output": "contract/clamp-output",
      "contract/entity-to-tensor": "contract/entity-to-tensor",
      "contract/tensor-to-payload": "contract/tensor-to-payload",
      "contract/validate-input": "contract/validate-input",
      "contract/validate-output": "contract/validate-output",
      "contract/violations": "contract/violations",
      "data/augment": "data/augment",
      "data/dataloader": "data/dataloader",
      "data/dataset": "data/dataset",
      "data/normalize": "data/normalize",
      "data/pad": "data/pad",
      "data/split": "data/split",
      "data/tokenize": "data/tokenize",
      despawn: "despawn",
      do: "do",
      "ease/apply": "ease/apply",
      "ease/smoothstep": "ease/smoothstep",
      emit: "emit",
      evaluate: "evaluate",
      fetch: "fetch",
      "fetch-stream": "fetch-stream",
      fn: "fn",
      "format/bytes": "format/bytes",
      "format/creditCard": "format/creditCard",
      "format/currency": "format/currency",
      "format/list": "format/list",
      "format/number": "format/number",
      "format/ordinal": "format/ordinal",
      "format/percent": "format/percent",
      "format/phone": "format/phone",
      "format/plural": "format/plural",
      forward: "forward",
      "geo/aabb-overlap": "geo/aabb-overlap",
      "geo/circle-overlap": "geo/circle-overlap",
      "geo/point-in-circle": "geo/point-in-circle",
      "geo/point-in-rect": "geo/point-in-rect",
      "geo/rect-circle-overlap": "geo/rect-circle-overlap",
      "geo/reflect": "geo/reflect",
      "geo/segment-intersect": "geo/segment-intersect",
      "graph/add-self-loops": "graph/add-self-loops",
      "graph/batch": "graph/batch",
      "graph/degree": "graph/degree",
      "graph/edge-features": "graph/edge-features",
      "graph/edge-index": "graph/edge-index",
      "graph/from-adjacency": "graph/from-adjacency",
      "graph/from-edge-list": "graph/from-edge-list",
      "graph/from-entities": "graph/from-entities",
      "graph/k-hop": "graph/k-hop",
      "graph/node-features": "graph/node-features",
      "graph/num-edges": "graph/num-edges",
      "graph/num-nodes": "graph/num-nodes",
      "graph/subgraph": "graph/subgraph",
      "graph/to-undirected": "graph/to-undirected",
      "grid/cells-in-radius": "grid/cells-in-radius",
      "grid/distance": "grid/distance",
      "grid/from-world": "grid/from-world",
      "grid/in-bounds": "grid/in-bounds",
      "grid/iso-to-screen": "grid/iso-to-screen",
      "grid/line": "grid/line",
      "grid/manhattan-distance": "grid/manhattan-distance",
      "grid/neighbors": "grid/neighbors",
      "grid/screen-to-iso": "grid/screen-to-iso",
      "grid/to-world": "grid/to-world",
      if: "if",
      "integration/github-create-issue": "integration/github-create-issue",
      "integration/github-get-repo": "integration/github-get-repo",
      "integration/http": "integration/http",
      let: "let",
      list: "list",
      "llm/call-tools": "llm/call-tools",
      "llm/compact": "llm/compact",
      "llm/embed": "llm/embed",
      "llm/generate": "llm/generate",
      "llm/switch": "llm/switch",
      "llm/token-count": "llm/token-count",
      log: "log",
      "lolo/emit-body": "lolo/emit-body",
      "math/abs": "math/abs",
      "math/acos": "math/acos",
      "math/approach": "math/approach",
      "math/asin": "math/asin",
      "math/atan": "math/atan",
      "math/atan2": "math/atan2",
      "math/ceil": "math/ceil",
      "math/clamp": "math/clamp",
      "math/cos": "math/cos",
      "math/default": "math/default",
      "math/deg-rad": "math/deg-rad",
      "math/floor": "math/floor",
      "math/hypot": "math/hypot",
      "math/lerp": "math/lerp",
      "math/map": "math/map",
      "math/max": "math/max",
      "math/min": "math/min",
      "math/mod": "math/mod",
      "math/pow": "math/pow",
      "math/rad-deg": "math/rad-deg",
      "math/random": "math/random",
      "math/randomInt": "math/randomInt",
      "math/round": "math/round",
      "math/sign": "math/sign",
      "math/sin": "math/sin",
      "math/sqrt": "math/sqrt",
      "math/tan": "math/tan",
      "math/wrap": "math/wrap",
      "memory/list": "memory/list",
      "memory/recall": "memory/recall",
      "memory/store": "memory/store",
      navigate: "navigate",
      "navigate-back": "navigate-back",
      "nn/batchnorm": "nn/batchnorm",
      "nn/clone": "nn/clone",
      "nn/dropout": "nn/dropout",
      "nn/forward": "nn/forward",
      "nn/getWeights": "nn/getWeights",
      "nn/layernorm": "nn/layernorm",
      "nn/linear": "nn/linear",
      "nn/paramCount": "nn/paramCount",
      "nn/relu": "nn/relu",
      "nn/sequential": "nn/sequential",
      "nn/setWeights": "nn/setWeights",
      "nn/sigmoid": "nn/sigmoid",
      "nn/softmax": "nn/softmax",
      "nn/tanh": "nn/tanh",
      "noise/fbm": "noise/fbm",
      "noise/perlin": "noise/perlin",
      "noise/simplex": "noise/simplex",
      not: "not",
      notify: "notify",
      "object/clone": "object/clone",
      "object/deepClone": "object/deepClone",
      "object/deepMerge": "object/deepMerge",
      "object/entries": "object/entries",
      "object/equals": "object/equals",
      "object/filter": "object/filter",
      "object/fromEntries": "object/fromEntries",
      "object/get": "object/get",
      "object/has": "object/has",
      "object/keys": "object/keys",
      "object/mapKeys": "object/mapKeys",
      "object/mapValues": "object/mapValues",
      "object/merge": "object/merge",
      "object/omit": "object/omit",
      "object/pick": "object/pick",
      "object/set": "object/set",
      "object/values": "object/values",
      or: "or",
      "os/debounce": "os/debounce",
      "os/watch-cron": "os/watch-cron",
      "os/watch-env": "os/watch-env",
      "os/watch-files": "os/watch-files",
      "os/watch-http": "os/watch-http",
      "os/watch-port": "os/watch-port",
      "os/watch-process": "os/watch-process",
      "os/watch-signal": "os/watch-signal",
      path: "path",
      "path/astar": "path/astar",
      "path/reachable": "path/reachable",
      persist: "persist",
      "prob/beta": "prob/beta",
      "prob/categorical": "prob/categorical",
      "prob/condition": "prob/condition",
      "prob/credible-interval": "prob/credible-interval",
      "prob/expected-value": "prob/expected-value",
      "prob/flip": "prob/flip",
      "prob/gaussian": "prob/gaussian",
      "prob/histogram": "prob/histogram",
      "prob/infer": "prob/infer",
      "prob/percentile": "prob/percentile",
      "prob/poisson": "prob/poisson",
      "prob/posterior": "prob/posterior",
      "prob/sample": "prob/sample",
      "prob/seed": "prob/seed",
      "prob/uniform": "prob/uniform",
      "prob/variance": "prob/variance",
      ref: "ref",
      "render-ui": "render-ui",
      "send-server": "send-server",
      "session/append-history": "session/append-history",
      "session/read-analysis": "session/read-analysis",
      "session/read-errors": "session/read-errors",
      "session/read-history": "session/read-history",
      "session/read-memory": "session/read-memory",
      "session/read-spec": "session/read-spec",
      "session/write-errors": "session/write-errors",
      "session/write-memory": "session/write-memory",
      "session/write-spec": "session/write-spec",
      set: "set",
      spawn: "spawn",
      "str/camelCase": "str/camelCase",
      "str/capitalize": "str/capitalize",
      "str/concat": "str/concat",
      "str/default": "str/default",
      "str/endsWith": "str/endsWith",
      "str/includes": "str/includes",
      "str/join": "str/join",
      "str/kebabCase": "str/kebabCase",
      "str/len": "str/len",
      "str/lower": "str/lower",
      "str/padEnd": "str/padEnd",
      "str/padStart": "str/padStart",
      "str/repeat": "str/repeat",
      "str/replace": "str/replace",
      "str/replaceAll": "str/replaceAll",
      "str/reverse": "str/reverse",
      "str/slice": "str/slice",
      "str/snakeCase": "str/snakeCase",
      "str/split": "str/split",
      "str/startsWith": "str/startsWith",
      "str/template": "str/template",
      "str/titleCase": "str/titleCase",
      "str/trim": "str/trim",
      "str/trimEnd": "str/trimEnd",
      "str/trimStart": "str/trimStart",
      "str/truncate": "str/truncate",
      "str/upper": "str/upper",
      "tensor/add": "tensor/add",
      "tensor/allInRange": "tensor/allInRange",
      "tensor/argmax": "tensor/argmax",
      "tensor/cat": "tensor/cat",
      "tensor/clamp": "tensor/clamp",
      "tensor/clampPerDim": "tensor/clampPerDim",
      "tensor/div": "tensor/div",
      "tensor/dot": "tensor/dot",
      "tensor/flatten": "tensor/flatten",
      "tensor/from": "tensor/from",
      "tensor/get": "tensor/get",
      "tensor/matmul": "tensor/matmul",
      "tensor/max": "tensor/max",
      "tensor/mean": "tensor/mean",
      "tensor/min": "tensor/min",
      "tensor/mul": "tensor/mul",
      "tensor/norm": "tensor/norm",
      "tensor/ones": "tensor/ones",
      "tensor/outOfRangeDims": "tensor/outOfRangeDims",
      "tensor/outOfRangeIndices": "tensor/outOfRangeIndices",
      "tensor/rand": "tensor/rand",
      "tensor/randn": "tensor/randn",
      "tensor/reshape": "tensor/reshape",
      "tensor/shape": "tensor/shape",
      "tensor/slice": "tensor/slice",
      "tensor/squeeze": "tensor/squeeze",
      "tensor/stack": "tensor/stack",
      "tensor/sub": "tensor/sub",
      "tensor/sum": "tensor/sum",
      "tensor/toArray": "tensor/toArray",
      "tensor/toList": "tensor/toList",
      "tensor/transpose": "tensor/transpose",
      "tensor/unsqueeze": "tensor/unsqueeze",
      "tensor/zeros": "tensor/zeros",
      "time/add": "time/add",
      "time/day": "time/day",
      "time/diff": "time/diff",
      "time/duration": "time/duration",
      "time/endOf": "time/endOf",
      "time/format": "time/format",
      "time/hour": "time/hour",
      "time/isAfter": "time/isAfter",
      "time/isBefore": "time/isBefore",
      "time/isBetween": "time/isBetween",
      "time/isFuture": "time/isFuture",
      "time/isPast": "time/isPast",
      "time/isSame": "time/isSame",
      "time/isToday": "time/isToday",
      "time/minute": "time/minute",
      "time/month": "time/month",
      "time/now": "time/now",
      "time/parse": "time/parse",
      "time/relative": "time/relative",
      "time/second": "time/second",
      "time/startOf": "time/startOf",
      "time/subtract": "time/subtract",
      "time/today": "time/today",
      "time/weekday": "time/weekday",
      "time/year": "time/year",
      "trace/emit": "trace/emit",
      "trace/log": "trace/log",
      train: "train",
      "train/adam": "train/adam",
      "train/checkConstraints": "train/checkConstraints",
      "train/checkForbiddenOutputs": "train/checkForbiddenOutputs",
      "train/checkRegression": "train/checkRegression",
      "train/checkWeightMagnitude": "train/checkWeightMagnitude",
      "train/clipGradients": "train/clipGradients",
      "train/clipWeights": "train/clipWeights",
      "train/computeAdvantages": "train/computeAdvantages",
      "train/computeReturns": "train/computeReturns",
      "train/crossEntropy": "train/crossEntropy",
      "train/getGradientNorm": "train/getGradientNorm",
      "train/getMaxWeightMagnitude": "train/getMaxWeightMagnitude",
      "train/huber": "train/huber",
      "train/loop": "train/loop",
      "train/mse": "train/mse",
      "train/sampleBatch": "train/sampleBatch",
      "train/sgd": "train/sgd",
      "train/step": "train/step",
      "train/validate": "train/validate",
      "validate/array": "validate/array",
      "validate/boolean": "validate/boolean",
      "validate/check": "validate/check",
      "validate/creditCard": "validate/creditCard",
      "validate/date": "validate/date",
      "validate/email": "validate/email",
      "validate/equals": "validate/equals",
      "validate/length": "validate/length",
      "validate/max": "validate/max",
      "validate/maxLength": "validate/maxLength",
      "validate/min": "validate/min",
      "validate/minLength": "validate/minLength",
      "validate/noneOf": "validate/noneOf",
      "validate/number": "validate/number",
      "validate/object": "validate/object",
      "validate/oneOf": "validate/oneOf",
      "validate/pattern": "validate/pattern",
      "validate/phone": "validate/phone",
      "validate/range": "validate/range",
      "validate/required": "validate/required",
      "validate/string": "validate/string",
      "validate/url": "validate/url",
      "validate/uuid": "validate/uuid",
      "validate/validate": "validate/validate",
      "vec/add": "vec/add",
      "vec/angle": "vec/angle",
      "vec/clamp-length": "vec/clamp-length",
      "vec/cross": "vec/cross",
      "vec/distance": "vec/distance",
      "vec/distance-sq": "vec/distance-sq",
      "vec/dot": "vec/dot",
      "vec/length": "vec/length",
      "vec/length-sq": "vec/length-sq",
      "vec/lerp": "vec/lerp",
      "vec/normalize": "vec/normalize",
      "vec/rotate": "vec/rotate",
      "vec/scale": "vec/scale",
      "vec/sub": "vec/sub",
      when: "when",
      "workspace/archive-orbital": "workspace/archive-orbital",
      "workspace/exists": "workspace/exists",
      "workspace/list-orbitals": "workspace/list-orbitals",
      "workspace/read-file": "workspace/read-file",
      "workspace/read-orbital": "workspace/read-orbital",
      "workspace/read-plan": "workspace/read-plan",
      "workspace/read-schema": "workspace/read-schema",
      "workspace/write-file": "workspace/write-file",
      "workspace/write-orbital": "workspace/write-orbital",
      "workspace/write-plan": "workspace/write-plan",
      "workspace/write-schema": "workspace/write-schema"
    },
    ar: {
      "!=": "\u0644\u0627_\u064A\u0633\u0627\u0648\u064A",
      "%": "\u0628\u0627\u0642\u064A_\u0627\u0644\u0642\u0633\u0645\u0629",
      "*": "\u0636\u0631\u0628",
      "+": "\u062C\u0645\u0639",
      "-": "\u0637\u0631\u062D",
      "/": "\u0642\u0633\u0645\u0629",
      "<": "\u0623\u0635\u063A\u0631_\u0645\u0646",
      "<=": "\u0623\u0635\u063A\u0631_\u0623\u0648_\u064A\u0633\u0627\u0648\u064A",
      "=": "\u064A\u0633\u0627\u0648\u064A",
      "==": "\u064A\u0633\u0627\u0648\u064A_\u062A\u0645\u0627\u0645\u0627",
      ">": "\u0623\u0643\u0628\u0631_\u0645\u0646",
      ">=": "\u0623\u0643\u0628\u0631_\u0623\u0648_\u064A\u0633\u0627\u0648\u064A",
      and: "\u0648",
      "anim/direction-from-delta": "\u0645\u062A\u062D\u0631\u0643\u0627\u062A/\u0627\u062A\u062C\u0627\u0647_\u0645\u0646_\u0641\u0631\u0642",
      "anim/frame-at": "\u0645\u062A\u062D\u0631\u0643\u0627\u062A/\u0625\u0637\u0627\u0631_\u0639\u0646\u062F",
      "anim/sheet-rect": "\u0645\u062A\u062D\u0631\u0643\u0627\u062A/\u0645\u0633\u062A\u0637\u064A\u0644_\u0635\u0641\u064A\u062D\u0629",
      "array/append": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0625\u0644\u062D\u0627\u0642",
      "array/avg": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0645\u062A\u0648\u0633\u0637",
      "array/concat": "\u0645\u0635\u0641\u0648\u0641\u0629/\u062F\u0645\u062C",
      "array/cosine": "\u0645\u0635\u0641\u0648\u0641\u0629/\u062A\u0634\u0627\u0628\u0647_\u062C\u064A\u0628_\u0627\u0644\u062A\u0645\u0627\u0645",
      "array/count": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0639\u062F",
      "array/drop": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0625\u0633\u0642\u0627\u0637",
      "array/dropLast": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0625\u0633\u0642\u0627\u0637_\u0627\u0644\u0623\u062E\u064A\u0631",
      "array/every": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0627\u0644\u0643\u0644",
      "array/filter": "\u0645\u0635\u0641\u0648\u0641\u0629/\u062A\u0635\u0641\u064A\u0629",
      "array/find": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0628\u062D\u062B",
      "array/findIndex": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0645\u0624\u0634\u0631_\u0628\u062D\u062B",
      "array/first": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0623\u0648\u0644",
      "array/flatten": "\u0645\u0635\u0641\u0648\u0641\u0629/\u062A\u0633\u0637\u064A\u062D",
      "array/groupBy": "\u0645\u0635\u0641\u0648\u0641\u0629/\u062A\u062C\u0645\u064A\u0639_\u0628\u0648\u0627\u0633\u0637\u0629",
      "array/includes": "\u0645\u0635\u0641\u0648\u0641\u0629/\u064A\u062A\u0636\u0645\u0646",
      "array/indexOf": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0645\u0624\u0634\u0631",
      "array/insert": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0625\u062F\u0631\u0627\u062C",
      "array/last": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0622\u062E\u0631",
      "array/len": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0637\u0648\u0644",
      "array/map": "\u0645\u0635\u0641\u0648\u0641\u0629/\u062A\u062D\u0648\u064A\u0644",
      "array/max": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0623\u0642\u0635\u0649",
      "array/min": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0623\u062F\u0646\u0649",
      "array/nearest": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0627\u0644\u0623\u0642\u0631\u0628",
      "array/nth": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0631\u0642\u0645",
      "array/partition": "\u0645\u0635\u0641\u0648\u0641\u0629/\u062A\u0642\u0633\u064A\u0645",
      "array/prepend": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0625\u0636\u0627\u0641\u0629_\u0644\u0644\u0628\u062F\u0627\u064A\u0629",
      "array/range": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0646\u0637\u0627\u0642",
      "array/reduce": "\u0645\u0635\u0641\u0648\u0641\u0629/\u062A\u0642\u0644\u064A\u0635",
      "array/reject": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0631\u0641\u0636",
      "array/remove": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0625\u0632\u0627\u0644\u0629",
      "array/removeItem": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0625\u0632\u0627\u0644\u0629_\u0639\u0646\u0635\u0631",
      "array/reverse": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0639\u0643\u0633",
      "array/shuffle": "\u0645\u0635\u0641\u0648\u0641\u0629/\u062E\u0644\u0637",
      "array/slice": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0634\u0631\u064A\u062D\u0629",
      "array/some": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0627\u0644\u0628\u0639\u0636",
      "array/sort": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0641\u0631\u0632",
      "array/sum": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0645\u062C\u0645\u0648\u0639",
      "array/take": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0623\u062E\u0630",
      "array/takeLast": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0623\u062E\u0630_\u0627\u0644\u0623\u062E\u064A\u0631",
      "array/unique": "\u0645\u0635\u0641\u0648\u0641\u0629/\u0641\u0631\u064A\u062F",
      "array/zip": "\u0645\u0635\u0641\u0648\u0641\u0629/\u062F\u0645\u062C_\u0645\u0632\u062F\u0648\u062C",
      "async/all": "\u062A\u0632\u0627\u0645\u0646/\u0627\u0644\u0643\u0644",
      "async/debounce": "\u062A\u0632\u0627\u0645\u0646/\u062A\u0623\u062E\u064A\u0631_\u062A\u0646\u0641\u064A\u0630",
      "async/delay": "\u062A\u0632\u0627\u0645\u0646/\u062A\u0623\u062E\u064A\u0631",
      "async/interval": "\u062A\u0632\u0627\u0645\u0646/\u0641\u0627\u0635\u0644_\u062F\u0648\u0631\u064A",
      "async/race": "\u062A\u0632\u0627\u0645\u0646/\u0633\u0628\u0627\u0642",
      "async/retry": "\u062A\u0632\u0627\u0645\u0646/\u0625\u0639\u0627\u062F\u0629_\u0645\u062D\u0627\u0648\u0644\u0629",
      "async/sequence": "\u062A\u0632\u0627\u0645\u0646/\u062A\u0633\u0644\u0633\u0644",
      "async/throttle": "\u062A\u0632\u0627\u0645\u0646/\u0643\u0628\u062D",
      "async/timeout": "\u062A\u0632\u0627\u0645\u0646/\u0645\u0647\u0644\u0629",
      "behavior/call": "\u0633\u0644\u0648\u0643/\u0627\u0633\u062A\u062F\u0639\u0627\u0621",
      "behavior/compose": "\u0633\u0644\u0648\u0643/\u062A\u0631\u0643\u064A\u0628",
      "behavior/detect-layout": "\u0633\u0644\u0648\u0643/\u0627\u0643\u062A\u0634\u0627\u0641_\u062A\u062E\u0637\u064A\u0637",
      "behavior/instantiate": "\u0633\u0644\u0648\u0643/\u0625\u0646\u0634\u0627\u0621_\u0646\u0633\u062E\u0629",
      "behavior/pipe": "\u0633\u0644\u0648\u0643/\u0623\u0646\u0628\u0648\u0628",
      "behavior/wire": "\u0633\u0644\u0648\u0643/\u0631\u0628\u0637_\u0623\u0633\u0644\u0627\u0643",
      "browser/clipboard-read": "\u0645\u062A\u0635\u0641\u062D/\u0642\u0631\u0627\u0621\u0629_\u0627\u0644\u062D\u0627\u0641\u0638\u0629",
      "browser/clipboard-write": "\u0645\u062A\u0635\u0641\u062D/\u0643\u062A\u0627\u0628\u0629_\u0627\u0644\u062D\u0627\u0641\u0638\u0629",
      "browser/geolocation-current": "\u0645\u062A\u0635\u0641\u062D/\u0627\u0644\u0645\u0648\u0642\u0639_\u0627\u0644\u062C\u063A\u0631\u0627\u0641\u064A_\u0627\u0644\u062D\u0627\u0644\u064A",
      "browser/open-file-picker": "\u0645\u062A\u0635\u0641\u062D/\u0641\u062A\u062D_\u0645\u0646\u062A\u0642\u064A_\u0627\u0644\u0645\u0644\u0641\u0627\u062A",
      "browser/push-subscribe": "\u0645\u062A\u0635\u0641\u062D/\u0627\u0634\u062A\u0631\u0627\u0643_\u0627\u0644\u062F\u0641\u0639",
      "call-service": "\u0627\u0633\u062A\u062F\u0639\u0627\u0621_\u062E\u062F\u0645\u0629",
      "checkpoint/load": "\u0646\u0642\u0637\u0629_\u062A\u0641\u062A\u064A\u0634/\u062A\u062D\u0645\u064A\u0644",
      "checkpoint/save": "\u0646\u0642\u0637\u0629_\u062A\u0641\u062A\u064A\u0634/\u062D\u0641\u0638",
      "compose/compose-all": "\u062A\u0631\u0643\u064A\u0628/\u062A\u0631\u0643\u064A\u0628_\u0627\u0644\u0643\u0644",
      "compose/compose-children": "\u062A\u0631\u0643\u064A\u0628/\u062A\u0631\u0643\u064A\u0628_\u0627\u0644\u0623\u0628\u0646\u0627\u0621",
      "contract/clamp-output": "\u0639\u0642\u062F/\u062D\u0635\u0631_\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A",
      "contract/entity-to-tensor": "\u0639\u0642\u062F/\u0643\u064A\u0627\u0646_\u0625\u0644\u0649_\u0645\u0648\u062A\u0631",
      "contract/tensor-to-payload": "\u0639\u0642\u062F/\u0645\u0648\u062A\u0631_\u0625\u0644\u0649_\u062D\u0645\u0648\u0644\u0629",
      "contract/validate-input": "\u0639\u0642\u062F/\u062A\u062D\u0642\u0642_\u0627\u0644\u0645\u062F\u062E\u0644\u0627\u062A",
      "contract/validate-output": "\u0639\u0642\u062F/\u062A\u062D\u0642\u0642_\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A",
      "contract/violations": "\u0639\u0642\u062F/\u0645\u062E\u0627\u0644\u0641\u0627\u062A",
      "data/augment": "\u0628\u064A\u0627\u0646\u0627\u062A/\u0632\u064A\u0627\u062F\u0629_\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
      "data/dataloader": "\u0628\u064A\u0627\u0646\u0627\u062A/\u0645\u062D\u0645\u0644_\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
      "data/dataset": "\u0628\u064A\u0627\u0646\u0627\u062A/\u0645\u062C\u0645\u0648\u0639\u0629_\u0628\u064A\u0627\u0646\u0627\u062A",
      "data/normalize": "\u0628\u064A\u0627\u0646\u0627\u062A/\u062A\u0633\u0648\u064A\u0629",
      "data/pad": "\u0628\u064A\u0627\u0646\u0627\u062A/\u062D\u0634\u0648",
      "data/split": "\u0628\u064A\u0627\u0646\u0627\u062A/\u062A\u0642\u0633\u064A\u0645",
      "data/tokenize": "\u0628\u064A\u0627\u0646\u0627\u062A/\u062A\u0631\u0645\u064A\u0632",
      despawn: "\u0625\u062E\u0641\u0627\u0621",
      do: "\u062A\u0646\u0641\u064A\u0630",
      "ease/apply": "\u062A\u0633\u0647\u064A\u0644/\u062A\u0637\u0628\u064A\u0642",
      "ease/smoothstep": "\u062A\u0633\u0647\u064A\u0644/\u062E\u0637\u0648\u0629_\u0646\u0627\u0639\u0645\u0629",
      emit: "\u0628\u062B",
      evaluate: "\u062A\u0642\u064A\u064A\u0645",
      fetch: "\u062C\u0644\u0628",
      "fetch-stream": "\u062C\u0644\u0628_\u0628\u062B",
      fn: "\u062F\u0627\u0644\u0629",
      "format/bytes": "\u062A\u0646\u0633\u064A\u0642/\u0628\u0627\u064A\u062A",
      "format/creditCard": "\u062A\u0646\u0633\u064A\u0642/\u0628\u0637\u0627\u0642\u0629_\u0627\u0626\u062A\u0645\u0627\u0646",
      "format/currency": "\u062A\u0646\u0633\u064A\u0642/\u0639\u0645\u0644\u0629",
      "format/list": "\u062A\u0646\u0633\u064A\u0642/\u0642\u0627\u0626\u0645\u0629",
      "format/number": "\u062A\u0646\u0633\u064A\u0642/\u0631\u0642\u0645",
      "format/ordinal": "\u062A\u0646\u0633\u064A\u0642/\u062A\u0631\u062A\u064A\u0628",
      "format/percent": "\u062A\u0646\u0633\u064A\u0642/\u0646\u0633\u0628\u0629",
      "format/phone": "\u062A\u0646\u0633\u064A\u0642/\u0647\u0627\u062A\u0641",
      "format/plural": "\u062A\u0646\u0633\u064A\u0642/\u062C\u0645\u0639",
      forward: "\u062A\u0645\u0631\u064A\u0631_\u0623\u0645\u0627\u0645\u064A",
      "geo/aabb-overlap": "\u062C\u063A\u0631\u0627\u0641\u064A\u0627/\u062A\u062F\u0627\u062E\u0644_\u0645\u0631\u0628\u0639_\u0645\u062D\u0627\u0630\u064A",
      "geo/circle-overlap": "\u062C\u063A\u0631\u0627\u0641\u064A\u0627/\u062A\u062F\u0627\u062E\u0644_\u062F\u0627\u0626\u0631\u0629",
      "geo/point-in-circle": "\u062C\u063A\u0631\u0627\u0641\u064A\u0627/\u0646\u0642\u0637\u0629_\u0641\u064A_\u062F\u0627\u0626\u0631\u0629",
      "geo/point-in-rect": "\u062C\u063A\u0631\u0627\u0641\u064A\u0627/\u0646\u0642\u0637\u0629_\u0641\u064A_\u0645\u0633\u062A\u0637\u064A\u0644",
      "geo/rect-circle-overlap": "\u062C\u063A\u0631\u0627\u0641\u064A\u0627/\u062A\u062F\u0627\u062E\u0644_\u0645\u0633\u062A\u0637\u064A\u0644_\u0648\u062F\u0627\u0626\u0631\u0629",
      "geo/reflect": "\u062C\u063A\u0631\u0627\u0641\u064A\u0627/\u0627\u0646\u0639\u0643\u0627\u0633",
      "geo/segment-intersect": "\u062C\u063A\u0631\u0627\u0641\u064A\u0627/\u062A\u0642\u0627\u0637\u0639_\u0642\u0637\u0639\u0629",
      "graph/add-self-loops": "\u0631\u0633\u0645_\u0628\u064A\u0627\u0646\u064A/\u0625\u0636\u0627\u0641\u0629_\u062D\u0644\u0642\u0627\u062A_\u0630\u0627\u062A\u064A\u0629",
      "graph/batch": "\u0631\u0633\u0645_\u0628\u064A\u0627\u0646\u064A/\u062A\u062C\u0645\u064A\u0639_\u062F\u0641\u0639\u0629",
      "graph/degree": "\u0631\u0633\u0645_\u0628\u064A\u0627\u0646\u064A/\u062F\u0631\u062C\u0629_\u0627\u0644\u0639\u0642\u062F\u0629",
      "graph/edge-features": "\u0631\u0633\u0645_\u0628\u064A\u0627\u0646\u064A/\u0645\u064A\u0632\u0627\u062A_\u0627\u0644\u0623\u0636\u0644\u0627\u0639",
      "graph/edge-index": "\u0631\u0633\u0645_\u0628\u064A\u0627\u0646\u064A/\u0645\u0624\u0634\u0631_\u0627\u0644\u0623\u0636\u0644\u0627\u0639",
      "graph/from-adjacency": "\u0631\u0633\u0645_\u0628\u064A\u0627\u0646\u064A/\u0645\u0646_\u0645\u0635\u0641\u0648\u0641\u0629_\u062A\u062C\u0627\u0648\u0631",
      "graph/from-edge-list": "\u0631\u0633\u0645_\u0628\u064A\u0627\u0646\u064A/\u0645\u0646_\u0642\u0627\u0626\u0645\u0629_\u0623\u0636\u0644\u0627\u0639",
      "graph/from-entities": "\u0631\u0633\u0645_\u0628\u064A\u0627\u0646\u064A/\u0645\u0646_\u0643\u064A\u0627\u0646\u0627\u062A",
      "graph/k-hop": "\u0631\u0633\u0645_\u0628\u064A\u0627\u0646\u064A/\u062C\u0648\u0627\u0631_\u0643_\u0642\u0641\u0632\u0629",
      "graph/node-features": "\u0631\u0633\u0645_\u0628\u064A\u0627\u0646\u064A/\u0645\u064A\u0632\u0627\u062A_\u0627\u0644\u0639\u0642\u062F",
      "graph/num-edges": "\u0631\u0633\u0645_\u0628\u064A\u0627\u0646\u064A/\u0639\u062F\u062F_\u0627\u0644\u0623\u0636\u0644\u0627\u0639",
      "graph/num-nodes": "\u0631\u0633\u0645_\u0628\u064A\u0627\u0646\u064A/\u0639\u062F\u062F_\u0627\u0644\u0639\u0642\u062F",
      "graph/subgraph": "\u0631\u0633\u0645_\u0628\u064A\u0627\u0646\u064A/\u0631\u0633\u0645_\u0641\u0631\u0639\u064A",
      "graph/to-undirected": "\u0631\u0633\u0645_\u0628\u064A\u0627\u0646\u064A/\u0625\u0644\u0649_\u063A\u064A\u0631_\u0645\u0648\u062C\u0647",
      "grid/cells-in-radius": "\u0634\u0628\u0643\u0629/\u062E\u0644\u0627\u064A\u0627_\u0636\u0645\u0646_\u0646\u0635\u0641_\u0642\u0637\u0631",
      "grid/distance": "\u0634\u0628\u0643\u0629/\u0645\u0633\u0627\u0641\u0629",
      "grid/from-world": "\u0634\u0628\u0643\u0629/\u0645\u0646_\u0627\u0644\u0639\u0627\u0644\u0645",
      "grid/in-bounds": "\u0634\u0628\u0643\u0629/\u0636\u0645\u0646_\u0627\u0644\u062D\u062F\u0648\u062F",
      "grid/iso-to-screen": "\u0634\u0628\u0643\u0629/\u0645\u062A\u0633\u0627\u0648\u064A_\u0627\u0644\u0642\u064A\u0627\u0633_\u0625\u0644\u0649_\u0634\u0627\u0634\u0629",
      "grid/line": "\u0634\u0628\u0643\u0629/\u062E\u0637",
      "grid/manhattan-distance": "\u0634\u0628\u0643\u0629/\u0645\u0633\u0627\u0641\u0629_\u0645\u0627\u0646\u0647\u0627\u062A\u0646",
      "grid/neighbors": "\u0634\u0628\u0643\u0629/\u0627\u0644\u062C\u064A\u0631\u0627\u0646",
      "grid/screen-to-iso": "\u0634\u0628\u0643\u0629/\u0634\u0627\u0634\u0629_\u0625\u0644\u0649_\u0645\u062A\u0633\u0627\u0648\u064A_\u0627\u0644\u0642\u064A\u0627\u0633",
      "grid/to-world": "\u0634\u0628\u0643\u0629/\u0625\u0644\u0649_\u0627\u0644\u0639\u0627\u0644\u0645",
      if: "\u0625\u0630\u0627",
      "integration/github-create-issue": "\u062A\u0643\u0627\u0645\u0644/\u0625\u0646\u0634\u0627\u0621_\u062A\u0630\u0643\u0631\u0629_\u062C\u064A\u062A_\u0647\u0628",
      "integration/github-get-repo": "\u062A\u0643\u0627\u0645\u0644/\u062C\u0644\u0628_\u0645\u0633\u062A\u0648\u062F\u0639_\u062C\u064A\u062A_\u0647\u0628",
      "integration/http": "\u062A\u0643\u0627\u0645\u0644/\u0637\u0644\u0628_\u0625\u062A\u0634_\u062A\u064A_\u062A\u064A_\u0628\u064A",
      let: "\u0644\u064A\u0643\u0646",
      list: "\u0642\u0627\u0626\u0645\u0629",
      "llm/call-tools": "\u0646\u0645\u0648\u0630\u062C_\u0644\u063A\u0648\u064A/\u0627\u0633\u062A\u062F\u0639\u0627\u0621_\u0623\u062F\u0648\u0627\u062A",
      "llm/compact": "\u0646\u0645\u0648\u0630\u062C_\u0644\u063A\u0648\u064A/\u0636\u063A\u0637_\u0627\u0644\u0633\u064A\u0627\u0642",
      "llm/embed": "\u0646\u0645\u0648\u0630\u062C_\u0644\u063A\u0648\u064A/\u062A\u0636\u0645\u064A\u0646",
      "llm/generate": "\u0646\u0645\u0648\u0630\u062C_\u0644\u063A\u0648\u064A/\u062A\u0648\u0644\u064A\u062F_\u0646\u0635",
      "llm/switch": "\u0646\u0645\u0648\u0630\u062C_\u0644\u063A\u0648\u064A/\u062A\u0628\u062F\u064A\u0644_\u0627\u0644\u0646\u0645\u0648\u0630\u062C",
      "llm/token-count": "\u0646\u0645\u0648\u0630\u062C_\u0644\u063A\u0648\u064A/\u0639\u062F\u062F_\u0627\u0644\u0631\u0645\u0648\u0632",
      log: "\u0633\u062C\u0644_\u0631\u0633\u0627\u0644\u0629",
      "lolo/emit-body": "\u0644\u0648\u0644\u0648/\u0628\u062B_\u0645\u062A\u0646_\u0645\u062F\u0627\u0631",
      "math/abs": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0642\u064A\u0645\u0629_\u0645\u0637\u0644\u0642\u0629",
      "math/acos": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0642\u0648\u0633_\u062C\u064A\u0628_\u0627\u0644\u062A\u0645\u0627\u0645",
      "math/approach": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0627\u0642\u062A\u0631\u0627\u0628",
      "math/asin": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0642\u0648\u0633_\u0627\u0644\u062C\u064A\u0628",
      "math/atan": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0642\u0648\u0633_\u0627\u0644\u0638\u0644",
      "math/atan2": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0642\u0648\u0633_\u0627\u0644\u0638\u06442",
      "math/ceil": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0633\u0642\u0641",
      "math/clamp": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u062D\u0635\u0631",
      "math/cos": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u062C\u064A\u0628_\u0627\u0644\u062A\u0645\u0627\u0645",
      "math/default": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0627\u0641\u062A\u0631\u0627\u0636\u064A",
      "math/deg-rad": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u062F\u0631\u062C\u0629_\u0625\u0644\u0649_\u0631\u0627\u062F\u064A\u0627\u0646",
      "math/floor": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0623\u0631\u0636\u064A\u0629",
      "math/hypot": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0648\u062A\u0631",
      "math/lerp": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0627\u0633\u062A\u064A\u0641\u0627\u0621_\u062E\u0637\u064A",
      "math/map": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u062A\u062D\u0648\u064A\u0644",
      "math/max": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0623\u0642\u0635\u0649",
      "math/min": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0623\u062F\u0646\u0649",
      "math/mod": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0628\u0627\u0642\u064A",
      "math/pow": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0623\u0633",
      "math/rad-deg": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0631\u0627\u062F\u064A\u0627\u0646_\u0625\u0644\u0649_\u062F\u0631\u062C\u0629",
      "math/random": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0639\u0634\u0648\u0627\u0626\u064A",
      "math/randomInt": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0639\u062F\u062F_\u0635\u062D\u064A\u062D_\u0639\u0634\u0648\u0627\u0626\u064A",
      "math/round": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u062A\u0642\u0631\u064A\u0628",
      "math/sign": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0625\u0634\u0627\u0631\u0629",
      "math/sin": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u062C\u064A\u0628",
      "math/sqrt": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u062C\u0630\u0631_\u062A\u0631\u0628\u064A\u0639\u064A",
      "math/tan": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0638\u0644",
      "math/wrap": "\u0631\u064A\u0627\u0636\u064A\u0627\u062A/\u0644\u0641",
      "memory/list": "\u0630\u0627\u0643\u0631\u0629/\u0633\u0631\u062F_\u0627\u0644\u0630\u0643\u0631\u064A\u0627\u062A",
      "memory/recall": "\u0630\u0627\u0643\u0631\u0629/\u0627\u0633\u062A\u0631\u062C\u0627\u0639",
      "memory/store": "\u0630\u0627\u0643\u0631\u0629/\u062A\u062E\u0632\u064A\u0646",
      navigate: "\u0627\u0646\u062A\u0642\u0627\u0644",
      "navigate-back": "\u0631\u062C\u0648\u0639",
      "nn/batchnorm": "\u0634\u0628\u0643\u0629_\u0639\u0635\u0628\u064A\u0629/\u062A\u0633\u0648\u064A\u0629_\u0627\u0644\u062F\u0641\u0639\u0629",
      "nn/clone": "\u0634\u0628\u0643\u0629_\u0639\u0635\u0628\u064A\u0629/\u0627\u0633\u062A\u0646\u0633\u0627\u062E",
      "nn/dropout": "\u0634\u0628\u0643\u0629_\u0639\u0635\u0628\u064A\u0629/\u0625\u0633\u0642\u0627\u0637_\u0639\u0634\u0648\u0627\u0626\u064A",
      "nn/forward": "\u0634\u0628\u0643\u0629_\u0639\u0635\u0628\u064A\u0629/\u062A\u0645\u0631\u064A\u0631_\u0623\u0645\u0627\u0645\u064A",
      "nn/getWeights": "\u0634\u0628\u0643\u0629_\u0639\u0635\u0628\u064A\u0629/\u062C\u0644\u0628_\u0627\u0644\u0623\u0648\u0632\u0627\u0646",
      "nn/layernorm": "\u0634\u0628\u0643\u0629_\u0639\u0635\u0628\u064A\u0629/\u062A\u0633\u0648\u064A\u0629_\u0627\u0644\u0637\u0628\u0642\u0629",
      "nn/linear": "\u0634\u0628\u0643\u0629_\u0639\u0635\u0628\u064A\u0629/\u0637\u0628\u0642\u0629_\u062E\u0637\u064A\u0629",
      "nn/paramCount": "\u0634\u0628\u0643\u0629_\u0639\u0635\u0628\u064A\u0629/\u0639\u062F\u062F_\u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A",
      "nn/relu": "\u0634\u0628\u0643\u0629_\u0639\u0635\u0628\u064A\u0629/\u062A\u0646\u0634\u064A\u0637_\u0631\u0644\u0648",
      "nn/sequential": "\u0634\u0628\u0643\u0629_\u0639\u0635\u0628\u064A\u0629/\u0634\u0628\u0643\u0629_\u0645\u062A\u0633\u0644\u0633\u0644\u0629",
      "nn/setWeights": "\u0634\u0628\u0643\u0629_\u0639\u0635\u0628\u064A\u0629/\u062A\u0639\u064A\u064A\u0646_\u0627\u0644\u0623\u0648\u0632\u0627\u0646",
      "nn/sigmoid": "\u0634\u0628\u0643\u0629_\u0639\u0635\u0628\u064A\u0629/\u062A\u0646\u0634\u064A\u0637_\u0633\u064A\u063A\u0645\u0648\u064A\u062F",
      "nn/softmax": "\u0634\u0628\u0643\u0629_\u0639\u0635\u0628\u064A\u0629/\u062A\u0646\u0634\u064A\u0637_\u0633\u0648\u0641\u062A_\u0645\u0627\u0643\u0633",
      "nn/tanh": "\u0634\u0628\u0643\u0629_\u0639\u0635\u0628\u064A\u0629/\u062A\u0646\u0634\u064A\u0637_\u062A\u0627\u0646\u062C",
      "noise/fbm": "\u0636\u0648\u0636\u0627\u0621/\u0636\u0648\u0636\u0627\u0621_\u0643\u0633\u064A\u0631\u064A\u0629",
      "noise/perlin": "\u0636\u0648\u0636\u0627\u0621/\u0636\u0648\u0636\u0627\u0621_\u0628\u064A\u0631\u0644\u064A\u0646",
      "noise/simplex": "\u0636\u0648\u0636\u0627\u0621/\u0636\u0648\u0636\u0627\u0621_\u0633\u064A\u0645\u0628\u0644\u0643\u0633",
      not: "\u0644\u064A\u0633",
      notify: "\u0625\u0634\u0639\u0627\u0631",
      "object/clone": "\u0643\u0627\u0626\u0646/\u0627\u0633\u062A\u0646\u0633\u0627\u062E",
      "object/deepClone": "\u0643\u0627\u0626\u0646/\u0627\u0633\u062A\u0646\u0633\u0627\u062E_\u0639\u0645\u064A\u0642",
      "object/deepMerge": "\u0643\u0627\u0626\u0646/\u062F\u0645\u062C_\u0639\u0645\u064A\u0642",
      "object/entries": "\u0643\u0627\u0626\u0646/\u0625\u062F\u062E\u0627\u0644\u0627\u062A",
      "object/equals": "\u0643\u0627\u0626\u0646/\u064A\u0633\u0627\u0648\u064A",
      "object/filter": "\u0643\u0627\u0626\u0646/\u062A\u0635\u0641\u064A\u0629",
      "object/fromEntries": "\u0643\u0627\u0626\u0646/\u0645\u0646_\u0625\u062F\u062E\u0627\u0644\u0627\u062A",
      "object/get": "\u0643\u0627\u0626\u0646/\u062C\u0644\u0628",
      "object/has": "\u0643\u0627\u0626\u0646/\u064A\u0645\u0644\u0643",
      "object/keys": "\u0643\u0627\u0626\u0646/\u0645\u0641\u0627\u062A\u064A\u062D",
      "object/mapKeys": "\u0643\u0627\u0626\u0646/\u062A\u062D\u0648\u064A\u0644_\u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D",
      "object/mapValues": "\u0643\u0627\u0626\u0646/\u062A\u062D\u0648\u064A\u0644_\u0627\u0644\u0642\u064A\u0645",
      "object/merge": "\u0643\u0627\u0626\u0646/\u062F\u0645\u062C",
      "object/omit": "\u0643\u0627\u0626\u0646/\u062A\u062C\u0627\u0647\u0644",
      "object/pick": "\u0643\u0627\u0626\u0646/\u0627\u062E\u062A\u0631",
      "object/set": "\u0643\u0627\u0626\u0646/\u062A\u0639\u064A\u064A\u0646",
      "object/values": "\u0643\u0627\u0626\u0646/\u0642\u064A\u0645",
      or: "\u0623\u0648",
      "os/debounce": "\u0646\u0638\u0627\u0645_\u062A\u0634\u063A\u064A\u0644/\u062A\u0623\u062E\u064A\u0631_\u062A\u0646\u0641\u064A\u0630",
      "os/watch-cron": "\u0646\u0638\u0627\u0645_\u062A\u0634\u063A\u064A\u0644/\u0645\u0631\u0627\u0642\u0628\u0629_\u062C\u062F\u0648\u0644\u0629",
      "os/watch-env": "\u0646\u0638\u0627\u0645_\u062A\u0634\u063A\u064A\u0644/\u0645\u0631\u0627\u0642\u0628\u0629_\u0628\u064A\u0626\u0629",
      "os/watch-files": "\u0646\u0638\u0627\u0645_\u062A\u0634\u063A\u064A\u0644/\u0645\u0631\u0627\u0642\u0628\u0629_\u0645\u0644\u0641\u0627\u062A",
      "os/watch-http": "\u0646\u0638\u0627\u0645_\u062A\u0634\u063A\u064A\u0644/\u0645\u0631\u0627\u0642\u0628\u0629_\u0625\u062A\u0634_\u062A\u064A_\u062A\u064A_\u0628\u064A",
      "os/watch-port": "\u0646\u0638\u0627\u0645_\u062A\u0634\u063A\u064A\u0644/\u0645\u0631\u0627\u0642\u0628\u0629_\u0645\u0646\u0641\u0630",
      "os/watch-process": "\u0646\u0638\u0627\u0645_\u062A\u0634\u063A\u064A\u0644/\u0645\u0631\u0627\u0642\u0628\u0629_\u0639\u0645\u0644\u064A\u0629",
      "os/watch-signal": "\u0646\u0638\u0627\u0645_\u062A\u0634\u063A\u064A\u0644/\u0645\u0631\u0627\u0642\u0628\u0629_\u0625\u0634\u0627\u0631\u0629",
      path: "\u0645\u0633\u0627\u0631",
      "path/astar": "\u0645\u0633\u0627\u0631/\u0623\u0642\u0635\u0631_\u0645\u0633\u0627\u0631",
      "path/reachable": "\u0645\u0633\u0627\u0631/\u0642\u0627\u0628\u0644_\u0627\u0644\u0648\u0635\u0648\u0644",
      persist: "\u062D\u0641\u0638",
      "prob/beta": "\u0627\u062D\u062A\u0645\u0627\u0644/\u0628\u064A\u062A\u0627",
      "prob/categorical": "\u0627\u062D\u062A\u0645\u0627\u0644/\u062A\u0635\u0646\u064A\u0641\u064A",
      "prob/condition": "\u0627\u062D\u062A\u0645\u0627\u0644/\u0634\u0631\u0637",
      "prob/credible-interval": "\u0627\u062D\u062A\u0645\u0627\u0644/\u0645\u062C\u0627\u0644_\u0645\u0648\u062B\u0648\u0642",
      "prob/expected-value": "\u0627\u062D\u062A\u0645\u0627\u0644/\u0642\u064A\u0645\u0629_\u0645\u062A\u0648\u0642\u0639\u0629",
      "prob/flip": "\u0627\u062D\u062A\u0645\u0627\u0644/\u0642\u0644\u0628",
      "prob/gaussian": "\u0627\u062D\u062A\u0645\u0627\u0644/\u063A\u0627\u0648\u0633\u064A",
      "prob/histogram": "\u0627\u062D\u062A\u0645\u0627\u0644/\u0645\u062F\u0631\u062C_\u062A\u0643\u0631\u0627\u0631\u064A",
      "prob/infer": "\u0627\u062D\u062A\u0645\u0627\u0644/\u0627\u0633\u062A\u062F\u0644\u0627\u0644",
      "prob/percentile": "\u0627\u062D\u062A\u0645\u0627\u0644/\u0645\u0626\u0648\u064A",
      "prob/poisson": "\u0627\u062D\u062A\u0645\u0627\u0644/\u0628\u0648\u0627\u0633\u0648\u0646",
      "prob/posterior": "\u0627\u062D\u062A\u0645\u0627\u0644/\u0628\u0639\u062F\u064A",
      "prob/sample": "\u0627\u062D\u062A\u0645\u0627\u0644/\u0639\u064A\u0646\u0629",
      "prob/seed": "\u0627\u062D\u062A\u0645\u0627\u0644/\u0628\u0630\u0631\u0629",
      "prob/uniform": "\u0627\u062D\u062A\u0645\u0627\u0644/\u0645\u0646\u062A\u0638\u0645",
      "prob/variance": "\u0627\u062D\u062A\u0645\u0627\u0644/\u062A\u0628\u0627\u064A\u0646",
      ref: "\u0645\u0631\u062C\u0639",
      "render-ui": "\u0639\u0631\u0636_\u0648\u0627\u062C\u0647\u0629",
      "send-server": "\u0625\u0631\u0633\u0627\u0644_\u0644\u0644\u062E\u0627\u062F\u0645",
      "session/append-history": "\u062C\u0644\u0633\u0629/\u0625\u0644\u062D\u0627\u0642_\u0627\u0644\u0633\u062C\u0644",
      "session/read-analysis": "\u062C\u0644\u0633\u0629/\u0642\u0631\u0627\u0621\u0629_\u0627\u0644\u062A\u062D\u0644\u064A\u0644",
      "session/read-errors": "\u062C\u0644\u0633\u0629/\u0642\u0631\u0627\u0621\u0629_\u0627\u0644\u0623\u062E\u0637\u0627\u0621",
      "session/read-history": "\u062C\u0644\u0633\u0629/\u0642\u0631\u0627\u0621\u0629_\u0627\u0644\u0633\u062C\u0644",
      "session/read-memory": "\u062C\u0644\u0633\u0629/\u0642\u0631\u0627\u0621\u0629_\u0627\u0644\u0630\u0627\u0643\u0631\u0629",
      "session/read-spec": "\u062C\u0644\u0633\u0629/\u0642\u0631\u0627\u0621\u0629_\u0627\u0644\u0645\u0648\u0627\u0635\u0641\u0629",
      "session/write-errors": "\u062C\u0644\u0633\u0629/\u0643\u062A\u0627\u0628\u0629_\u0627\u0644\u0623\u062E\u0637\u0627\u0621",
      "session/write-memory": "\u062C\u0644\u0633\u0629/\u0643\u062A\u0627\u0628\u0629_\u0627\u0644\u0630\u0627\u0643\u0631\u0629",
      "session/write-spec": "\u062C\u0644\u0633\u0629/\u0643\u062A\u0627\u0628\u0629_\u0627\u0644\u0645\u0648\u0627\u0635\u0641\u0629",
      set: "\u062A\u0639\u064A\u064A\u0646",
      spawn: "\u062A\u0648\u0644\u064A\u062F",
      "str/camelCase": "\u0646\u0635/\u062D\u0627\u0644\u0629_\u0627\u0644\u062C\u0645\u0644",
      "str/capitalize": "\u0646\u0635/\u0628\u062F\u0627\u064A\u0629_\u0643\u0628\u064A\u0631\u0629",
      "str/concat": "\u0646\u0635/\u062F\u0645\u062C",
      "str/default": "\u0646\u0635/\u0627\u0641\u062A\u0631\u0627\u0636\u064A",
      "str/endsWith": "\u0646\u0635/\u064A\u0646\u062A\u0647\u064A_\u0628\u0640",
      "str/includes": "\u0646\u0635/\u064A\u062A\u0636\u0645\u0646",
      "str/join": "\u0646\u0635/\u0636\u0645",
      "str/kebabCase": "\u0646\u0635/\u062D\u0627\u0644\u0629_\u0627\u0644\u0634\u0631\u0637\u0629",
      "str/len": "\u0646\u0635/\u0637\u0648\u0644",
      "str/lower": "\u0646\u0635/\u0635\u063A\u064A\u0631",
      "str/padEnd": "\u0646\u0635/\u062D\u0634\u0648_\u0627\u0644\u0646\u0647\u0627\u064A\u0629",
      "str/padStart": "\u0646\u0635/\u062D\u0634\u0648_\u0627\u0644\u0628\u062F\u0627\u064A\u0629",
      "str/repeat": "\u0646\u0635/\u062A\u0643\u0631\u0627\u0631",
      "str/replace": "\u0646\u0635/\u0627\u0633\u062A\u0628\u062F\u0627\u0644",
      "str/replaceAll": "\u0646\u0635/\u0627\u0633\u062A\u0628\u062F\u0627\u0644_\u0627\u0644\u0643\u0644",
      "str/reverse": "\u0646\u0635/\u0639\u0643\u0633",
      "str/slice": "\u0646\u0635/\u0634\u0631\u064A\u062D\u0629",
      "str/snakeCase": "\u0646\u0635/\u062D\u0627\u0644\u0629_\u0627\u0644\u0623\u0641\u0639\u0649",
      "str/split": "\u0646\u0635/\u062A\u0642\u0633\u064A\u0645",
      "str/startsWith": "\u0646\u0635/\u064A\u0628\u062F\u0623_\u0628\u0640",
      "str/template": "\u0646\u0635/\u0642\u0627\u0644\u0628",
      "str/titleCase": "\u0646\u0635/\u062D\u0627\u0644\u0629_\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
      "str/trim": "\u0646\u0635/\u062A\u0642\u0644\u064A\u0645",
      "str/trimEnd": "\u0646\u0635/\u062A\u0642\u0644\u064A\u0645_\u0627\u0644\u0646\u0647\u0627\u064A\u0629",
      "str/trimStart": "\u0646\u0635/\u062A\u0642\u0644\u064A\u0645_\u0627\u0644\u0628\u062F\u0627\u064A\u0629",
      "str/truncate": "\u0646\u0635/\u0628\u062A\u0631",
      "str/upper": "\u0646\u0635/\u0643\u0628\u064A\u0631",
      "tensor/add": "\u0645\u0648\u062A\u0631/\u062C\u0645\u0639",
      "tensor/allInRange": "\u0645\u0648\u062A\u0631/\u0627\u0644\u0643\u0644_\u0636\u0645\u0646_\u0627\u0644\u0646\u0637\u0627\u0642",
      "tensor/argmax": "\u0645\u0648\u062A\u0631/\u0645\u0624\u0634\u0631_\u0627\u0644\u0623\u0642\u0635\u0649",
      "tensor/cat": "\u0645\u0648\u062A\u0631/\u0631\u0628\u0637",
      "tensor/clamp": "\u0645\u0648\u062A\u0631/\u062D\u0635\u0631",
      "tensor/clampPerDim": "\u0645\u0648\u062A\u0631/\u062D\u0635\u0631_\u0644\u0643\u0644_\u0628\u0639\u062F",
      "tensor/div": "\u0645\u0648\u062A\u0631/\u0642\u0633\u0645\u0629",
      "tensor/dot": "\u0645\u0648\u062A\u0631/\u0636\u0631\u0628_\u0646\u0642\u0637\u064A",
      "tensor/flatten": "\u0645\u0648\u062A\u0631/\u062A\u0633\u0637\u064A\u062D",
      "tensor/from": "\u0645\u0648\u062A\u0631/\u0645\u0646_\u0645\u0635\u0641\u0648\u0641\u0629",
      "tensor/get": "\u0645\u0648\u062A\u0631/\u062C\u0644\u0628",
      "tensor/matmul": "\u0645\u0648\u062A\u0631/\u0636\u0631\u0628_\u0645\u0635\u0641\u0648\u0641\u064A",
      "tensor/max": "\u0645\u0648\u062A\u0631/\u0623\u0642\u0635\u0649",
      "tensor/mean": "\u0645\u0648\u062A\u0631/\u0645\u062A\u0648\u0633\u0637",
      "tensor/min": "\u0645\u0648\u062A\u0631/\u0623\u062F\u0646\u0649",
      "tensor/mul": "\u0645\u0648\u062A\u0631/\u0636\u0631\u0628",
      "tensor/norm": "\u0645\u0648\u062A\u0631/\u0645\u0639\u064A\u0627\u0631",
      "tensor/ones": "\u0645\u0648\u062A\u0631/\u0622\u062D\u0627\u062F",
      "tensor/outOfRangeDims": "\u0645\u0648\u062A\u0631/\u0623\u0628\u0639\u0627\u062F_\u062E\u0627\u0631\u062C_\u0627\u0644\u0646\u0637\u0627\u0642",
      "tensor/outOfRangeIndices": "\u0645\u0648\u062A\u0631/\u0645\u0624\u0634\u0631\u0627\u062A_\u062E\u0627\u0631\u062C_\u0627\u0644\u0646\u0637\u0627\u0642",
      "tensor/rand": "\u0645\u0648\u062A\u0631/\u0639\u0634\u0648\u0627\u0626\u064A",
      "tensor/randn": "\u0645\u0648\u062A\u0631/\u0639\u0634\u0648\u0627\u0626\u064A_\u0637\u0628\u064A\u0639\u064A",
      "tensor/reshape": "\u0645\u0648\u062A\u0631/\u0625\u0639\u0627\u062F\u0629_\u062A\u0634\u0643\u064A\u0644",
      "tensor/shape": "\u0645\u0648\u062A\u0631/\u0634\u0643\u0644",
      "tensor/slice": "\u0645\u0648\u062A\u0631/\u0634\u0631\u064A\u062D\u0629",
      "tensor/squeeze": "\u0645\u0648\u062A\u0631/\u0639\u0635\u0631",
      "tensor/stack": "\u0645\u0648\u062A\u0631/\u0631\u0635",
      "tensor/sub": "\u0645\u0648\u062A\u0631/\u0637\u0631\u062D",
      "tensor/sum": "\u0645\u0648\u062A\u0631/\u0645\u062C\u0645\u0648\u0639",
      "tensor/toArray": "\u0645\u0648\u062A\u0631/\u0625\u0644\u0649_\u0645\u0635\u0641\u0648\u0641\u0629",
      "tensor/toList": "\u0645\u0648\u062A\u0631/\u0625\u0644\u0649_\u0642\u0627\u0626\u0645\u0629",
      "tensor/transpose": "\u0645\u0648\u062A\u0631/\u0646\u0642\u0644",
      "tensor/unsqueeze": "\u0645\u0648\u062A\u0631/\u0641\u0631\u062F",
      "tensor/zeros": "\u0645\u0648\u062A\u0631/\u0623\u0635\u0641\u0627\u0631",
      "time/add": "\u0648\u0642\u062A/\u0625\u0636\u0627\u0641\u0629",
      "time/day": "\u0648\u0642\u062A/\u064A\u0648\u0645",
      "time/diff": "\u0648\u0642\u062A/\u0641\u0631\u0642",
      "time/duration": "\u0648\u0642\u062A/\u0645\u062F\u0629",
      "time/endOf": "\u0648\u0642\u062A/\u0646\u0647\u0627\u064A\u0629",
      "time/format": "\u0648\u0642\u062A/\u062A\u0646\u0633\u064A\u0642",
      "time/hour": "\u0648\u0642\u062A/\u0633\u0627\u0639\u0629",
      "time/isAfter": "\u0648\u0642\u062A/\u0628\u0639\u062F",
      "time/isBefore": "\u0648\u0642\u062A/\u0642\u0628\u0644",
      "time/isBetween": "\u0648\u0642\u062A/\u0628\u064A\u0646",
      "time/isFuture": "\u0648\u0642\u062A/\u0645\u0633\u062A\u0642\u0628\u0644",
      "time/isPast": "\u0648\u0642\u062A/\u0645\u0627\u0636\u064A",
      "time/isSame": "\u0648\u0642\u062A/\u0645\u0637\u0627\u0628\u0642",
      "time/isToday": "\u0648\u0642\u062A/\u0627\u0644\u064A\u0648\u0645\u061F",
      "time/minute": "\u0648\u0642\u062A/\u062F\u0642\u064A\u0642\u0629",
      "time/month": "\u0648\u0642\u062A/\u0634\u0647\u0631",
      "time/now": "\u0648\u0642\u062A/\u0627\u0644\u0622\u0646",
      "time/parse": "\u0648\u0642\u062A/\u062A\u062D\u0644\u064A\u0644",
      "time/relative": "\u0648\u0642\u062A/\u0646\u0633\u0628\u064A",
      "time/second": "\u0648\u0642\u062A/\u062B\u0627\u0646\u064A\u0629",
      "time/startOf": "\u0648\u0642\u062A/\u0628\u062F\u0627\u064A\u0629",
      "time/subtract": "\u0648\u0642\u062A/\u0637\u0631\u062D",
      "time/today": "\u0648\u0642\u062A/\u0627\u0644\u064A\u0648\u0645",
      "time/weekday": "\u0648\u0642\u062A/\u064A\u0648\u0645_\u0623\u0633\u0628\u0648\u0639",
      "time/year": "\u0648\u0642\u062A/\u0633\u0646\u0629",
      "trace/emit": "\u062A\u062A\u0628\u0639/\u0628\u062B",
      "trace/log": "\u062A\u062A\u0628\u0639/\u062A\u0633\u062C\u064A\u0644",
      train: "\u062A\u062F\u0631\u064A\u0628",
      "train/adam": "\u062A\u062F\u0631\u064A\u0628/\u0622\u062F\u0645",
      "train/checkConstraints": "\u062A\u062F\u0631\u064A\u0628/\u0641\u062D\u0635_\u0627\u0644\u0642\u064A\u0648\u062F",
      "train/checkForbiddenOutputs": "\u062A\u062F\u0631\u064A\u0628/\u0641\u062D\u0635_\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A_\u0627\u0644\u0645\u062D\u0638\u0648\u0631\u0629",
      "train/checkRegression": "\u062A\u062F\u0631\u064A\u0628/\u0641\u062D\u0635_\u0627\u0644\u062A\u0631\u0627\u062C\u0639",
      "train/checkWeightMagnitude": "\u062A\u062F\u0631\u064A\u0628/\u0641\u062D\u0635_\u062D\u062C\u0645_\u0627\u0644\u0623\u0648\u0632\u0627\u0646",
      "train/clipGradients": "\u062A\u062F\u0631\u064A\u0628/\u0642\u0635_\u0627\u0644\u062A\u062F\u0631\u062C\u0627\u062A",
      "train/clipWeights": "\u062A\u062F\u0631\u064A\u0628/\u0642\u0635_\u0627\u0644\u0623\u0648\u0632\u0627\u0646",
      "train/computeAdvantages": "\u062A\u062F\u0631\u064A\u0628/\u062D\u0633\u0627\u0628_\u0627\u0644\u0623\u0641\u0636\u0644\u064A\u0627\u062A",
      "train/computeReturns": "\u062A\u062F\u0631\u064A\u0628/\u062D\u0633\u0627\u0628_\u0627\u0644\u0639\u0648\u0627\u0626\u062F",
      "train/crossEntropy": "\u062A\u062F\u0631\u064A\u0628/\u0625\u0646\u062A\u0631\u0648\u0628\u064A\u0627_\u062A\u0642\u0627\u0637\u0639\u064A\u0629",
      "train/getGradientNorm": "\u062A\u062F\u0631\u064A\u0628/\u0645\u0639\u064A\u0627\u0631_\u0627\u0644\u062A\u062F\u0631\u062C",
      "train/getMaxWeightMagnitude": "\u062A\u062F\u0631\u064A\u0628/\u0623\u0642\u0635\u0649_\u062D\u062C\u0645_\u0648\u0632\u0646",
      "train/huber": "\u062A\u062F\u0631\u064A\u0628/\u062E\u0633\u0627\u0631\u0629_\u0647\u0648\u0628\u0631",
      "train/loop": "\u062A\u062F\u0631\u064A\u0628/\u062D\u0644\u0642\u0629_\u0627\u0644\u062A\u062F\u0631\u064A\u0628",
      "train/mse": "\u062A\u062F\u0631\u064A\u0628/\u0645\u062A\u0648\u0633\u0637_\u0645\u0631\u0628\u0639_\u0627\u0644\u062E\u0637\u0623",
      "train/sampleBatch": "\u062A\u062F\u0631\u064A\u0628/\u0639\u064A\u0646\u0629_\u062F\u0641\u0639\u0629",
      "train/sgd": "\u062A\u062F\u0631\u064A\u0628/\u0627\u0646\u062D\u062F\u0627\u0631_\u062A\u062F\u0631\u062C\u064A_\u0639\u0634\u0648\u0627\u0626\u064A",
      "train/step": "\u062A\u062F\u0631\u064A\u0628/\u062E\u0637\u0648\u0629_\u062A\u062F\u0631\u064A\u0628",
      "train/validate": "\u062A\u062F\u0631\u064A\u0628/\u062A\u062D\u0642\u0642_\u0627\u0644\u0646\u0645\u0648\u0630\u062C",
      "validate/array": "\u062A\u062D\u0642\u0642/\u0645\u0635\u0641\u0648\u0641\u0629",
      "validate/boolean": "\u062A\u062D\u0642\u0642/\u0645\u0646\u0637\u0642\u064A",
      "validate/check": "\u062A\u062D\u0642\u0642/\u0641\u062D\u0635",
      "validate/creditCard": "\u062A\u062D\u0642\u0642/\u0628\u0637\u0627\u0642\u0629_\u0627\u0626\u062A\u0645\u0627\u0646",
      "validate/date": "\u062A\u062D\u0642\u0642/\u062A\u0627\u0631\u064A\u062E",
      "validate/email": "\u062A\u062D\u0642\u0642/\u0628\u0631\u064A\u062F",
      "validate/equals": "\u062A\u062D\u0642\u0642/\u064A\u0633\u0627\u0648\u064A",
      "validate/length": "\u062A\u062D\u0642\u0642/\u0637\u0648\u0644",
      "validate/max": "\u062A\u062D\u0642\u0642/\u0623\u0642\u0635\u0649",
      "validate/maxLength": "\u062A\u062D\u0642\u0642/\u0637\u0648\u0644_\u0623\u0642\u0635\u0649",
      "validate/min": "\u062A\u062D\u0642\u0642/\u0623\u062F\u0646\u0649",
      "validate/minLength": "\u062A\u062D\u0642\u0642/\u0637\u0648\u0644_\u0623\u062F\u0646\u0649",
      "validate/noneOf": "\u062A\u062D\u0642\u0642/\u0644\u0627_\u0634\u064A\u0621_\u0645\u0646",
      "validate/number": "\u062A\u062D\u0642\u0642/\u0631\u0642\u0645",
      "validate/object": "\u062A\u062D\u0642\u0642/\u0643\u0627\u0626\u0646",
      "validate/oneOf": "\u062A\u062D\u0642\u0642/\u0648\u0627\u062D\u062F_\u0645\u0646",
      "validate/pattern": "\u062A\u062D\u0642\u0642/\u0646\u0645\u0637",
      "validate/phone": "\u062A\u062D\u0642\u0642/\u0647\u0627\u062A\u0641",
      "validate/range": "\u062A\u062D\u0642\u0642/\u0646\u0637\u0627\u0642",
      "validate/required": "\u062A\u062D\u0642\u0642/\u0645\u0637\u0644\u0648\u0628",
      "validate/string": "\u062A\u062D\u0642\u0642/\u0646\u0635",
      "validate/url": "\u062A\u062D\u0642\u0642/\u0631\u0627\u0628\u0637",
      "validate/uuid": "\u062A\u062D\u0642\u0642/\u0645\u0639\u0631\u0641",
      "validate/validate": "\u062A\u062D\u0642\u0642/\u062A\u062D\u0642\u0642_\u0639\u0627\u0645",
      "vec/add": "\u0645\u062A\u062C\u0647/\u062C\u0645\u0639",
      "vec/angle": "\u0645\u062A\u062C\u0647/\u0632\u0627\u0648\u064A\u0629",
      "vec/clamp-length": "\u0645\u062A\u062C\u0647/\u062D\u0635\u0631_\u0627\u0644\u0637\u0648\u0644",
      "vec/cross": "\u0645\u062A\u062C\u0647/\u0636\u0631\u0628_\u0627\u062A\u062C\u0627\u0647\u064A",
      "vec/distance": "\u0645\u062A\u062C\u0647/\u0645\u0633\u0627\u0641\u0629",
      "vec/distance-sq": "\u0645\u062A\u062C\u0647/\u0645\u0631\u0628\u0639_\u0627\u0644\u0645\u0633\u0627\u0641\u0629",
      "vec/dot": "\u0645\u062A\u062C\u0647/\u0636\u0631\u0628_\u0646\u0642\u0637\u064A",
      "vec/length": "\u0645\u062A\u062C\u0647/\u0637\u0648\u0644",
      "vec/length-sq": "\u0645\u062A\u062C\u0647/\u0645\u0631\u0628\u0639_\u0627\u0644\u0637\u0648\u0644",
      "vec/lerp": "\u0645\u062A\u062C\u0647/\u0627\u0633\u062A\u064A\u0641\u0627\u0621_\u062E\u0637\u064A",
      "vec/normalize": "\u0645\u062A\u062C\u0647/\u062A\u0633\u0648\u064A\u0629",
      "vec/rotate": "\u0645\u062A\u062C\u0647/\u062F\u0648\u0631\u0627\u0646",
      "vec/scale": "\u0645\u062A\u062C\u0647/\u062A\u062D\u062C\u064A\u0645",
      "vec/sub": "\u0645\u062A\u062C\u0647/\u0637\u0631\u062D",
      when: "\u0639\u0646\u062F\u0645\u0627",
      "workspace/archive-orbital": "\u0645\u0633\u0627\u062D\u0629_\u0639\u0645\u0644/\u0623\u0631\u0634\u0641\u0629_\u0645\u062F\u0627\u0631",
      "workspace/exists": "\u0645\u0633\u0627\u062D\u0629_\u0639\u0645\u0644/\u0645\u0648\u062C\u0648\u062F\u061F",
      "workspace/list-orbitals": "\u0645\u0633\u0627\u062D\u0629_\u0639\u0645\u0644/\u0633\u0631\u062F_\u0627\u0644\u0645\u062F\u0627\u0631\u0627\u062A",
      "workspace/read-file": "\u0645\u0633\u0627\u062D\u0629_\u0639\u0645\u0644/\u0642\u0631\u0627\u0621\u0629_\u0645\u0644\u0641",
      "workspace/read-orbital": "\u0645\u0633\u0627\u062D\u0629_\u0639\u0645\u0644/\u0642\u0631\u0627\u0621\u0629_\u0645\u062F\u0627\u0631",
      "workspace/read-plan": "\u0645\u0633\u0627\u062D\u0629_\u0639\u0645\u0644/\u0642\u0631\u0627\u0621\u0629_\u062E\u0637\u0629",
      "workspace/read-schema": "\u0645\u0633\u0627\u062D\u0629_\u0639\u0645\u0644/\u0642\u0631\u0627\u0621\u0629_\u0645\u062E\u0637\u0637",
      "workspace/write-file": "\u0645\u0633\u0627\u062D\u0629_\u0639\u0645\u0644/\u0643\u062A\u0627\u0628\u0629_\u0645\u0644\u0641",
      "workspace/write-orbital": "\u0645\u0633\u0627\u062D\u0629_\u0639\u0645\u0644/\u0643\u062A\u0627\u0628\u0629_\u0645\u062F\u0627\u0631",
      "workspace/write-plan": "\u0645\u0633\u0627\u062D\u0629_\u0639\u0645\u0644/\u0643\u062A\u0627\u0628\u0629_\u062E\u0637\u0629",
      "workspace/write-schema": "\u0645\u0633\u0627\u062D\u0629_\u0639\u0645\u0644/\u0643\u062A\u0627\u0628\u0629_\u0645\u062E\u0637\u0637"
    },
    sl: {
      "!=": "ne_enako",
      "%": "modul",
      "*": "krat",
      "+": "plus",
      "-": "minus",
      "/": "deljeno",
      "<": "manj",
      "<=": "manj_enako",
      "=": "je",
      "==": "enako",
      ">": "vec",
      ">=": "vec_enako",
      and: "in",
      "anim/direction-from-delta": "animacija/smer-iz-delta",
      "anim/frame-at": "animacija/okvir-pri",
      "anim/sheet-rect": "animacija/ploskev-pravokotnik",
      "array/append": "seznam/dodaj",
      "array/avg": "seznam/povprecje",
      "array/concat": "seznam/zdruzi",
      "array/cosine": "seznam/kosinus",
      "array/count": "seznam/stevec",
      "array/drop": "seznam/izpusti",
      "array/dropLast": "seznam/izpustiZadnji",
      "array/every": "seznam/vsak",
      "array/filter": "seznam/filtriraj",
      "array/find": "seznam/najdi",
      "array/findIndex": "seznam/najdiIndeks",
      "array/first": "seznam/prvi",
      "array/flatten": "seznam/splosci",
      "array/groupBy": "seznam/skupinaPo",
      "array/includes": "seznam/vkljucuje",
      "array/indexOf": "seznam/indeksOd",
      "array/insert": "seznam/vstavi",
      "array/last": "seznam/zadnji",
      "array/len": "seznam/dolzina",
      "array/map": "seznam/preslikaj",
      "array/max": "seznam/najvec",
      "array/min": "seznam/najmanj",
      "array/nearest": "seznam/najblizji",
      "array/nth": "seznam/nti",
      "array/partition": "seznam/razdeli",
      "array/prepend": "seznam/dodajNaZacetek",
      "array/range": "seznam/razpon",
      "array/reduce": "seznam/zmanjsaj",
      "array/reject": "seznam/zavrni",
      "array/remove": "seznam/odstrani",
      "array/removeItem": "seznam/odstraniElement",
      "array/reverse": "seznam/obrni",
      "array/shuffle": "seznam/premesaj",
      "array/slice": "seznam/rezina",
      "array/some": "seznam/nekateri",
      "array/sort": "seznam/razvrsti",
      "array/sum": "seznam/vsota",
      "array/take": "seznam/vzemi",
      "array/takeLast": "seznam/vzemiZadnji",
      "array/unique": "seznam/edinstveno",
      "array/zip": "seznam/zadrga",
      "async/all": "asink/vsi",
      "async/debounce": "asink/zadrzi",
      "async/delay": "asink/zakasnitev",
      "async/interval": "asink/interval",
      "async/race": "asink/dirka",
      "async/retry": "asink/ponovniPoskus",
      "async/sequence": "asink/zaporedje",
      "async/throttle": "asink/duse",
      "async/timeout": "asink/casovnaOmejitev",
      "behavior/call": "vedenje/poklici",
      "behavior/compose": "vedenje/sestavi",
      "behavior/detect-layout": "vedenje/zaznaj-postavitev",
      "behavior/instantiate": "vedenje/ustvariPrimerek",
      "behavior/pipe": "vedenje/cevovod",
      "behavior/wire": "vedenje/zvezi",
      "browser/clipboard-read": "brskalnik/odlozisce-beri",
      "browser/clipboard-write": "brskalnik/odlozisce-pisi",
      "browser/geolocation-current": "brskalnik/geolokacija-sedanje",
      "browser/open-file-picker": "brskalnik/odpri-datoteka-izbirnik",
      "browser/push-subscribe": "brskalnik/potisni-naroci",
      "call-service": "poklici-storitev",
      "checkpoint/load": "tocka/nalozi",
      "checkpoint/save": "tocka/shrani",
      "compose/compose-all": "sestava/sestavi-vsi",
      "compose/compose-children": "sestava/sestavi-otroci",
      "contract/clamp-output": "pogodba/omeji-rezultat",
      "contract/entity-to-tensor": "pogodba/entiteta-do-tenzor",
      "contract/tensor-to-payload": "pogodba/tenzor-do-podatki",
      "contract/validate-input": "pogodba/validiraj-vnos",
      "contract/validate-output": "pogodba/validiraj-rezultat",
      "contract/violations": "pogodba/krsitve",
      "data/augment": "podatki/obogati",
      "data/dataloader": "podatki/nalagalnikPodatkov",
      "data/dataset": "podatki/podatkovnaMnozica",
      "data/normalize": "podatki/normaliziraj",
      "data/pad": "podatki/zapolni",
      "data/split": "podatki/razdeli",
      "data/tokenize": "podatki/tokeniziraj",
      despawn: "odstrani",
      do: "naredi",
      "ease/apply": "glajenje/uporabi",
      "ease/smoothstep": "glajenje/glajenkorak",
      emit: "oddaj",
      evaluate: "ovrednoti",
      fetch: "pridobi",
      "fetch-stream": "pridobi-tok",
      fn: "fn",
      "format/bytes": "zapis/bajti",
      "format/creditCard": "zapis/kreditnaKartica",
      "format/currency": "zapis/valuta",
      "format/list": "zapis/seznam",
      "format/number": "zapis/stevilo",
      "format/ordinal": "zapis/vrstilni",
      "format/percent": "zapis/odstotek",
      "format/phone": "zapis/telefon",
      "format/plural": "zapis/mnozina",
      forward: "posreduj",
      "geo/aabb-overlap": "geom/aabb-prekrivanje",
      "geo/circle-overlap": "geom/krog-prekrivanje",
      "geo/point-in-circle": "geom/tocka-v-krog",
      "geo/point-in-rect": "geom/tocka-v-pravokotnik",
      "geo/rect-circle-overlap": "geom/pravokotnik-krog-prekrivanje",
      "geo/reflect": "geom/zrcali",
      "geo/segment-intersect": "geom/odsek-sekaj",
      "graph/add-self-loops": "graf/dodaj-sebe-zanke",
      "graph/batch": "graf/sveznj",
      "graph/degree": "graf/stopnja",
      "graph/edge-features": "graf/lok-znacilke",
      "graph/edge-index": "graf/lok-indeks",
      "graph/from-adjacency": "graf/iz-sosednost",
      "graph/from-edge-list": "graf/iz-lok-seznam",
      "graph/from-entities": "graf/iz-entitete",
      "graph/k-hop": "graf/k-skok",
      "graph/node-features": "graf/vozlisce-znacilke",
      "graph/num-edges": "graf/stevilo-loki",
      "graph/num-nodes": "graf/stevilo-vozlisca",
      "graph/subgraph": "graf/podgraf",
      "graph/to-undirected": "graf/do-neusmerjeno",
      "grid/cells-in-radius": "mreza/celice-v-polmer",
      "grid/distance": "mreza/razdalja",
      "grid/from-world": "mreza/iz-svet",
      "grid/in-bounds": "mreza/v-meje",
      "grid/iso-to-screen": "mreza/iso-do-zaslon",
      "grid/line": "mreza/crta",
      "grid/manhattan-distance": "mreza/manhattan-razdalja",
      "grid/neighbors": "mreza/sosedje",
      "grid/screen-to-iso": "mreza/zaslon-do-iso",
      "grid/to-world": "mreza/do-svet",
      if: "ce",
      "integration/github-create-issue": "integracija/github-ustvari-zadeva",
      "integration/github-get-repo": "integracija/github-dobi-repozitorij",
      "integration/http": "integracija/http",
      let: "naj",
      list: "seznam",
      "llm/call-tools": "llm/poklici-orodja",
      "llm/compact": "llm/stisnjeno",
      "llm/embed": "llm/vgraditev",
      "llm/generate": "llm/generiraj",
      "llm/switch": "llm/preklopi",
      "llm/token-count": "llm/zeton-stevec",
      log: "beleji",
      "lolo/emit-body": "lolo/oddaj-telo",
      "math/abs": "mat/abs",
      "math/acos": "mat/acos",
      "math/approach": "mat/priblizaj",
      "math/asin": "mat/asin",
      "math/atan": "mat/atan",
      "math/atan2": "mat/atan2",
      "math/ceil": "mat/strop",
      "math/clamp": "mat/omeji",
      "math/cos": "mat/cos",
      "math/default": "mat/privzeto",
      "math/deg-rad": "mat/stopinje-radiani",
      "math/floor": "mat/tla",
      "math/hypot": "mat/hipotenuza",
      "math/lerp": "mat/lerp",
      "math/map": "mat/preslikaj",
      "math/max": "mat/najvec",
      "math/min": "mat/najmanj",
      "math/mod": "mat/mod",
      "math/pow": "mat/potenca",
      "math/rad-deg": "mat/radiani-stopinje",
      "math/random": "mat/nakljucno",
      "math/randomInt": "mat/nakljucnoCelo",
      "math/round": "mat/zaokrozi",
      "math/sign": "mat/predznak",
      "math/sin": "mat/sin",
      "math/sqrt": "mat/koren",
      "math/tan": "mat/tan",
      "math/wrap": "mat/zavij",
      "memory/list": "spomin/seznam",
      "memory/recall": "spomin/obnovi",
      "memory/store": "spomin/shrani",
      navigate: "pojdi",
      "navigate-back": "pojdi-nazaj",
      "nn/batchnorm": "nevmreza/batchnorm",
      "nn/clone": "nevmreza/kloniraj",
      "nn/dropout": "nevmreza/dropout",
      "nn/forward": "nevmreza/posreduj",
      "nn/getWeights": "nevmreza/dobiUtezi",
      "nn/layernorm": "nevmreza/layernorm",
      "nn/linear": "nevmreza/linearno",
      "nn/paramCount": "nevmreza/parameterStevec",
      "nn/relu": "nevmreza/relu",
      "nn/sequential": "nevmreza/zaporedno",
      "nn/setWeights": "nevmreza/nastaviUtezi",
      "nn/sigmoid": "nevmreza/sigmoid",
      "nn/softmax": "nevmreza/softmax",
      "nn/tanh": "nevmreza/tanh",
      "noise/fbm": "sum/fbm",
      "noise/perlin": "sum/perlin",
      "noise/simplex": "sum/simplex",
      not: "ne",
      notify: "obvesti",
      "object/clone": "objekt/kloniraj",
      "object/deepClone": "objekt/globokoKloniraj",
      "object/deepMerge": "objekt/globokoZlij",
      "object/entries": "objekt/vnosi",
      "object/equals": "objekt/enako",
      "object/filter": "objekt/filtriraj",
      "object/fromEntries": "objekt/izVnosi",
      "object/get": "objekt/dobi",
      "object/has": "objekt/ima",
      "object/keys": "objekt/kljuci",
      "object/mapKeys": "objekt/preslikajKljuci",
      "object/mapValues": "objekt/preslikajVrednosti",
      "object/merge": "objekt/zlij",
      "object/omit": "objekt/izloci",
      "object/pick": "objekt/izberi",
      "object/set": "objekt/nastavi",
      "object/values": "objekt/vrednosti",
      or: "ali",
      "os/debounce": "os/zadrzi",
      "os/watch-cron": "os/spremljaj-cron",
      "os/watch-env": "os/spremljaj-okolje",
      "os/watch-files": "os/spremljaj-datoteke",
      "os/watch-http": "os/spremljaj-http",
      "os/watch-port": "os/spremljaj-vrata",
      "os/watch-process": "os/spremljaj-proces",
      "os/watch-signal": "os/spremljaj-signal",
      path: "pot",
      "path/astar": "pot/astar",
      "path/reachable": "pot/dosegljivo",
      persist: "shrani",
      "prob/beta": "verjetnost/beta",
      "prob/categorical": "verjetnost/kategoricno",
      "prob/condition": "verjetnost/pogoj",
      "prob/credible-interval": "verjetnost/verodostojno-interval",
      "prob/expected-value": "verjetnost/pricakovano-vrednost",
      "prob/flip": "verjetnost/vrzi",
      "prob/gaussian": "verjetnost/gaussovo",
      "prob/histogram": "verjetnost/histogram",
      "prob/infer": "verjetnost/sklepaj",
      "prob/percentile": "verjetnost/percentil",
      "prob/poisson": "verjetnost/poisson",
      "prob/posterior": "verjetnost/posteriorna",
      "prob/sample": "verjetnost/vzorec",
      "prob/seed": "verjetnost/seme",
      "prob/uniform": "verjetnost/enakomerno",
      "prob/variance": "verjetnost/varianca",
      ref: "sklic",
      "render-ui": "izrisi-vmesnik",
      "send-server": "posli-streznik",
      "session/append-history": "seja/dodaj-zgodovina",
      "session/read-analysis": "seja/beri-analiza",
      "session/read-errors": "seja/beri-napake",
      "session/read-history": "seja/beri-zgodovina",
      "session/read-memory": "seja/beri-spomin",
      "session/read-spec": "seja/beri-specifikacija",
      "session/write-errors": "seja/pisi-napake",
      "session/write-memory": "seja/pisi-spomin",
      "session/write-spec": "seja/pisi-specifikacija",
      set: "nastavi",
      spawn: "ustvari",
      "str/camelCase": "niz/kameljaPisava",
      "str/capitalize": "niz/velikaZacetnica",
      "str/concat": "niz/zdruzi",
      "str/default": "niz/privzeto",
      "str/endsWith": "niz/koncaS",
      "str/includes": "niz/vkljucuje",
      "str/join": "niz/pridruzi",
      "str/kebabCase": "niz/kebabPisava",
      "str/len": "niz/dolzina",
      "str/lower": "niz/maleCrke",
      "str/padEnd": "niz/zapolniKonec",
      "str/padStart": "niz/zapolniZacetek",
      "str/repeat": "niz/ponovi",
      "str/replace": "niz/zamenjaj",
      "str/replaceAll": "niz/zamenjajVsi",
      "str/reverse": "niz/obrni",
      "str/slice": "niz/rezina",
      "str/snakeCase": "niz/kacjaCrtaPisava",
      "str/split": "niz/razdeli",
      "str/startsWith": "niz/zacneS",
      "str/template": "niz/predloga",
      "str/titleCase": "niz/nazivPisava",
      "str/trim": "niz/obrezi",
      "str/trimEnd": "niz/obreziKonec",
      "str/trimStart": "niz/obreziZacetek",
      "str/truncate": "niz/skrajsaj",
      "str/upper": "niz/velikeCrke",
      "tensor/add": "tenzor/dodaj",
      "tensor/allInRange": "tenzor/vsiVRazpon",
      "tensor/argmax": "tenzor/argmax",
      "tensor/cat": "tenzor/spoji",
      "tensor/clamp": "tenzor/omeji",
      "tensor/clampPerDim": "tenzor/omejiNaDimenzija",
      "tensor/div": "tenzor/deli",
      "tensor/dot": "tenzor/pika",
      "tensor/flatten": "tenzor/splosci",
      "tensor/from": "tenzor/iz",
      "tensor/get": "tenzor/dobi",
      "tensor/matmul": "tenzor/matmul",
      "tensor/max": "tenzor/najvec",
      "tensor/mean": "tenzor/povprecna",
      "tensor/min": "tenzor/najmanj",
      "tensor/mul": "tenzor/mnozi",
      "tensor/norm": "tenzor/norma",
      "tensor/ones": "tenzor/enice",
      "tensor/outOfRangeDims": "tenzor/venOdRazponDimenzije",
      "tensor/outOfRangeIndices": "tenzor/venOdRazponIndeksi",
      "tensor/rand": "tenzor/nakljucniTenzor",
      "tensor/randn": "tenzor/nakljucniNormalni",
      "tensor/reshape": "tenzor/preoblikuj",
      "tensor/shape": "tenzor/oblika",
      "tensor/slice": "tenzor/rezina",
      "tensor/squeeze": "tenzor/stisni",
      "tensor/stack": "tenzor/sklad",
      "tensor/sub": "tenzor/odstej",
      "tensor/sum": "tenzor/vsota",
      "tensor/toArray": "tenzor/doPolje",
      "tensor/toList": "tenzor/doSeznam",
      "tensor/transpose": "tenzor/transponiraj",
      "tensor/unsqueeze": "tenzor/razsiriDim",
      "tensor/zeros": "tenzor/nicle",
      "time/add": "cas/dodaj",
      "time/day": "cas/dan",
      "time/diff": "cas/razlika",
      "time/duration": "cas/trajanje",
      "time/endOf": "cas/konecOd",
      "time/format": "cas/zapis",
      "time/hour": "cas/ura",
      "time/isAfter": "cas/jePo",
      "time/isBefore": "cas/jePred",
      "time/isBetween": "cas/jeMed",
      "time/isFuture": "cas/jePrihodnje",
      "time/isPast": "cas/jePreteklo",
      "time/isSame": "cas/jeEnako",
      "time/isToday": "cas/jeDanes",
      "time/minute": "cas/minuta",
      "time/month": "cas/mesec",
      "time/now": "cas/zdaj",
      "time/parse": "cas/razcleni",
      "time/relative": "cas/relativno",
      "time/second": "cas/sekunda",
      "time/startOf": "cas/zacetekOd",
      "time/subtract": "cas/odstej",
      "time/today": "cas/danes",
      "time/weekday": "cas/danVTednu",
      "time/year": "cas/leto",
      "trace/emit": "sled/oddaj",
      "trace/log": "sled/beleji",
      train: "treniraj",
      "train/adam": "treniraj/adam",
      "train/checkConstraints": "treniraj/preveriOmejitve",
      "train/checkForbiddenOutputs": "treniraj/preveriPrepovedanoRezultati",
      "train/checkRegression": "treniraj/preveriRegresija",
      "train/checkWeightMagnitude": "treniraj/preveriUtezMagnituda",
      "train/clipGradients": "treniraj/prireziGradienti",
      "train/clipWeights": "treniraj/prireziUtezi",
      "train/computeAdvantages": "treniraj/izracunajPrednosti",
      "train/computeReturns": "treniraj/izracunajDonosi",
      "train/crossEntropy": "treniraj/krizEntropija",
      "train/getGradientNorm": "treniraj/dobiGradientNorma",
      "train/getMaxWeightMagnitude": "treniraj/dobiNajvecUtezMagnituda",
      "train/huber": "treniraj/huber",
      "train/loop": "treniraj/zanka",
      "train/mse": "treniraj/mse",
      "train/sampleBatch": "treniraj/vzorecSveznj",
      "train/sgd": "treniraj/sgd",
      "train/step": "treniraj/korak",
      "train/validate": "treniraj/validiraj",
      "validate/array": "validacija/polje",
      "validate/boolean": "validacija/logicno",
      "validate/check": "validacija/preveri",
      "validate/creditCard": "validacija/kreditnaKartica",
      "validate/date": "validacija/datum",
      "validate/email": "validacija/eposta",
      "validate/equals": "validacija/enako",
      "validate/length": "validacija/dolzina",
      "validate/max": "validacija/najvec",
      "validate/maxLength": "validacija/najvecDolzina",
      "validate/min": "validacija/najmanj",
      "validate/minLength": "validacija/najmanjDolzina",
      "validate/noneOf": "validacija/brezOd",
      "validate/number": "validacija/stevilo",
      "validate/object": "validacija/objekt",
      "validate/oneOf": "validacija/enaOd",
      "validate/pattern": "validacija/vzorec",
      "validate/phone": "validacija/telefon",
      "validate/range": "validacija/razpon",
      "validate/required": "validacija/obvezno",
      "validate/string": "validacija/niz",
      "validate/url": "validacija/url",
      "validate/uuid": "validacija/uuid",
      "validate/validate": "validacija/validiraj",
      "vec/add": "vek/dodaj",
      "vec/angle": "vek/kot",
      "vec/clamp-length": "vek/omeji-dolzina",
      "vec/cross": "vek/kriz",
      "vec/distance": "vek/razdalja",
      "vec/distance-sq": "vek/razdalja-kvadrat",
      "vec/dot": "vek/pika",
      "vec/length": "vek/dolzina",
      "vec/length-sq": "vek/dolzina-kvadrat",
      "vec/lerp": "vek/lerp",
      "vec/normalize": "vek/normaliziraj",
      "vec/rotate": "vek/zavrti",
      "vec/scale": "vek/merilo",
      "vec/sub": "vek/odstej",
      when: "ko",
      "workspace/archive-orbital": "delovniprostor/arhiviraj-orbitala",
      "workspace/exists": "delovniprostor/obstaja",
      "workspace/list-orbitals": "delovniprostor/seznam-orbitale",
      "workspace/read-file": "delovniprostor/beri-datoteka",
      "workspace/read-orbital": "delovniprostor/beri-orbitala",
      "workspace/read-plan": "delovniprostor/beri-nacrt",
      "workspace/read-schema": "delovniprostor/beri-shema",
      "workspace/write-file": "delovniprostor/pisi-datoteka",
      "workspace/write-orbital": "delovniprostor/pisi-orbitala",
      "workspace/write-plan": "delovniprostor/pisi-nacrt",
      "workspace/write-schema": "delovniprostor/pisi-shema"
    }
  }
};

// src/shared.ts
function escapeRegex(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function wordsToPattern(words) {
  const sorted = [...words].sort((a, b) => b.length - a.length);
  return sorted.map(escapeRegex).join("|");
}
var UNICODE_WORD_EDGE = "[\\p{L}\\p{N}_-]";
function unicodeBoundaryRegExp(alternation) {
  return new RegExp(`(?<!${UNICODE_WORD_EDGE})(?:${alternation})(?!${UNICODE_WORD_EDGE})`, "u");
}
function wordsToUnicodePattern(words) {
  return unicodeBoundaryRegExp(wordsToPattern(words));
}
function wordsToAnchoredPattern(words) {
  return new RegExp(`^(?:${wordsToPattern(words)})$`, "u");
}
var allOpsSet = new Set(tokens_default.allOperatorNames);
var patternsSet = new Set(tokens_default.patternNames);
var NATIVE_LANGUAGES = ["ar", "sl"];
var operatorTableCache = /* @__PURE__ */ new Map();
function stdOperatorTables(lang) {
  const cached = operatorTableCache.get(lang);
  if (cached) return cached;
  const table = parseOperatorTables(
    { operators: tokens_default.i18nOperators[lang] },
    `@almadar/syntax tokens.json#i18nOperators.${lang}`
  );
  operatorTableCache.set(lang, table);
  return table;
}
function translateLolo(source, lang) {
  return localizeLoloSource(source, lang, { operators: stdOperatorTables(lang) });
}
function translateOrb(json, lang) {
  const options = { operators: stdOperatorTables(lang) };
  if (typeof json !== "string") return localizeOrbValue(json, lang, options);
  let parsed;
  try {
    parsed = JSON.parse(json);
  } catch {
    return json;
  }
  return JSON.stringify(localizeOrbValue(parsed, lang, options), null, 2);
}
var vocabularyCache = /* @__PURE__ */ new Map();
function vocabulary(lang) {
  const cached = vocabularyCache.get(lang);
  if (cached) return cached;
  const map = localizeMap(lang, stdOperatorTables(lang));
  vocabularyCache.set(lang, map);
  return map;
}
var WORD_SHAPED = /^[A-Za-z_][A-Za-z0-9_/-]*$/;
function multilingualWords(words) {
  const out = new Set(words);
  for (const lang of NATIVE_LANGUAGES) {
    const map = vocabulary(lang);
    for (const word of words) {
      if (!WORD_SHAPED.test(word)) continue;
      const native = map.get(word);
      if (native !== void 0) out.add(native);
    }
  }
  return [...out];
}
function nativeWords(words) {
  const english = new Set(words);
  return multilingualWords(words).filter((word) => !english.has(word));
}
function multilingualOrbKeys(keys) {
  const out = new Set(keys);
  for (const lang of NATIVE_LANGUAGES) {
    const table = coreTables[lang].orb;
    for (const key of keys) {
      const native = table[key];
      if (native !== void 0) out.add(native);
    }
  }
  return [...out];
}
var reservedEventWords = multilingualWords(
  Object.keys(coreTables.en.reservedEvents)
);
var nativeShapeWords = nativeWords(
  Object.keys(coreTables.en.shapes)
);

// src/prism-orb.ts
var operatorsByNamespace = {};
for (const [ns, ops] of Object.entries(tokens_default.operatorsByNamespace)) {
  operatorsByNamespace[ns] = multilingualWords(ops);
}
var effectTypes = multilingualWords(tokens_default.effectTypes);
var structuralKeys = multilingualOrbKeys(tokens_default.structuralKeys);
var fieldTypes = multilingualWords(tokens_default.fieldTypes);
var persistenceKinds = multilingualWords(tokens_default.persistenceKinds);
var uiSlots = multilingualWords(tokens_default.uiSlots);
var sigilRoots = multilingualWords([
  "entity",
  "payload",
  "state",
  "now",
  "config",
  "computed",
  "trait",
  "user"
]);
var namespacePatterns = {};
for (const [ns, ops] of Object.entries(operatorsByNamespace)) {
  if (ops.length > 0) {
    namespacePatterns[ns] = new RegExp(`^"(${wordsToPattern(ops)})"$`, "u");
  }
}
var effectPattern = new RegExp(`^"(${wordsToPattern(effectTypes)})"$`, "u");
var structuralPattern = new RegExp(`^"(${wordsToPattern(structuralKeys)})"$`, "u");
var fieldTypePattern = new RegExp(`^"(${wordsToPattern(fieldTypes)})"$`, "u");
var persistencePattern = new RegExp(`^"(${wordsToPattern(persistenceKinds)})"$`, "u");
var slotPattern = new RegExp(`^"(${wordsToPattern(uiSlots)})"$`, "u");
var eventPattern = new RegExp(`^"(?:[A-Z][A-Z0-9_]{2,}|${wordsToPattern(reservedEventWords)})"$`, "u");
var bindingPattern = new RegExp(
  `^"@(?:(?:${wordsToPattern(sigilRoots)})|[A-Z][a-zA-Z0-9]*)(?:\\.[\\p{L}\\p{N}_.]+)?"$`,
  "u"
);
var patternNamesPattern = tokens_default.patternNames.length > 0 ? new RegExp(`^"(${wordsToPattern(tokens_default.patternNames)})"$`, "u") : null;
var behaviorPattern = tokens_default.behaviorNames.length > 0 ? new RegExp(`^"(${wordsToPattern(tokens_default.behaviorNames)})"$`, "u") : null;
function registerOrbLanguage(Prism) {
  const languages = Prism.languages;
  const json = languages.json;
  if (!json) {
    console.warn("[almadar-syntax] Prism JSON language not found. Load it first.");
    return;
  }
  const orbInside = {};
  orbInside["orb-binding"] = new RegExp(
    `"@(?:(?:${wordsToPattern(sigilRoots)})|[A-Z][a-zA-Z0-9]*)(?:\\.[\\p{L}\\p{N}_.]+)?"`,
    "u"
  );
  if (effectTypes.length > 0) {
    orbInside["orb-effect"] = new RegExp(`"(?:${wordsToPattern(effectTypes)})"`, "u");
  }
  for (const [ns, ops] of Object.entries(operatorsByNamespace)) {
    if (ops.length > 0) {
      orbInside[`orb-op-${ns}`] = new RegExp(`"(?:${wordsToPattern(ops)})"`, "u");
    }
  }
  orbInside["orb-event"] = new RegExp(
    `"(?:[A-Z][A-Z0-9_]{2,}|${wordsToPattern(reservedEventWords)})"`,
    "u"
  );
  if (uiSlots.length > 0) {
    orbInside["orb-slot"] = new RegExp(`"(?:${wordsToPattern(uiSlots)})"`, "u");
  }
  if (structuralKeys.length > 0) {
    orbInside["orb-structural"] = new RegExp(`"(?:${wordsToPattern(structuralKeys)})"`, "u");
  }
  if (fieldTypes.length > 0) {
    orbInside["orb-field-type"] = new RegExp(`"(?:${wordsToPattern(fieldTypes)})"`, "u");
  }
  if (persistenceKinds.length > 0) {
    orbInside["orb-persistence"] = new RegExp(`"(?:${wordsToPattern(persistenceKinds)})"`, "u");
  }
  if (tokens_default.patternNames.length > 0) {
    orbInside["orb-pattern"] = new RegExp(`"(?:${wordsToPattern(tokens_default.patternNames)})"`);
  }
  if (tokens_default.behaviorNames.length > 0) {
    orbInside["orb-behavior"] = new RegExp(`"(?:${wordsToPattern(tokens_default.behaviorNames)})"`);
  }
  orbInside["orb-unknown-op"] = /"[a-z][a-z0-9_-]*\/[a-z][a-z0-9/_-]*"/;
  const jsonProp = json.property;
  const jsonStr = json.string;
  languages.orb = {
    ...json,
    property: {
      ...typeof jsonProp === "object" ? jsonProp : { pattern: jsonProp },
      inside: orbInside
    },
    string: {
      ...typeof jsonStr === "object" ? jsonStr : { pattern: jsonStr },
      inside: orbInside
    }
  };
}
function classifyOrbToken(quotedString) {
  if (bindingPattern.test(quotedString)) return "binding";
  if (effectPattern.test(quotedString)) return "effect";
  for (const [ns, pattern] of Object.entries(namespacePatterns)) {
    if (pattern.test(quotedString)) return ns;
  }
  if (eventPattern.test(quotedString)) return "event";
  if (slotPattern.test(quotedString)) return "slot";
  if (structuralPattern.test(quotedString)) return "structural";
  if (fieldTypePattern.test(quotedString)) return "fieldType";
  if (persistencePattern.test(quotedString)) return "persistence";
  if (patternNamesPattern?.test(quotedString)) return "pattern";
  if (behaviorPattern?.test(quotedString)) return "behavior";
  return "string";
}
function isRegisteredOperator(name) {
  return allOpsSet.has(name);
}
function isRegisteredPattern(name) {
  return patternsSet.has(name);
}

// src/refractor-orb.ts
function orbLanguage(Prism) {
  registerOrbLanguage(Prism);
}
orbLanguage.displayName = "orb";
orbLanguage.aliases = [];

// src/lolo/prism-lolo.ts
var effectList = multilingualWords(tokens_default.effectTypes);
var operatorNamespaces = {};
for (const [ns, ops] of Object.entries(tokens_default.operatorsByNamespace)) {
  if (ns !== "effect") {
    operatorNamespaces[ns] = multilingualWords(ops);
  }
}
var patternNamesPattern2 = tokens_default.patternNames.length > 0 ? wordsToUnicodePattern(tokens_default.patternNames) : null;
var behaviorNamesPattern = tokens_default.behaviorNames.length > 0 ? new RegExp(`(?:${wordsToPattern(tokens_default.behaviorNames)})`) : null;
function buildLoloGrammar() {
  const opTokens = {};
  for (const [ns, ops] of Object.entries(operatorNamespaces)) {
    if (ops.length === 0) continue;
    opTokens[`lolo-op-${ns}`] = wordsToUnicodePattern(ops);
  }
  const unknownOpPattern = /(?<![a-zA-Z0-9_-])[a-z][a-z0-9_]*\/[a-z][a-z0-9/_-]*(?![a-zA-Z0-9_-])/;
  return {
    // ── 1. Block comment: #= ... =# ─────────────────────────────────────────
    "block-comment": {
      pattern: /#=[\s\S]*?=#/,
      greedy: true
    },
    // ── 2. Line comments: # (not followed by =) and ;; ──────────────────────
    "comment": {
      pattern: /(?:;;|#(?!=)).*$/m,
      greedy: true
    },
    // ── 3. String literals ──────────────────────────────────────────────────
    "string": {
      pattern: /"(?:[^"\\]|\\.)*"/,
      greedy: true,
      // Inside strings: highlight behavior paths and pattern names.
      // e.g. "std/behaviors/std-modal" → lolo-behavior
      //      "data-grid" (in render-ui) → lolo-pattern
      inside: {
        ...behaviorNamesPattern ? { "lolo-behavior": { pattern: behaviorNamesPattern } } : {},
        ...patternNamesPattern2 ? { "lolo-pattern": { pattern: patternNamesPattern2 } } : {}
      }
    },
    // ── 4. Binding sigils: @field, @field.sub, ?field ───────────────────────
    // These are the most distinctive LOLO primitive — no equivalent in
    // Haskell. Cyan to match AvlBindingRef in .orb and AVL design system.
    "lolo-binding": /[@?][\p{L}_][\p{L}\p{N}_.]*/u,
    // ── 5. Dotted qualified references: Modal.traits.X, Browse.entity ───────
    // Like qualified module names in Haskell: Data.List.sort.
    // Must come before plain constructor names so the whole path is consumed.
    "lolo-reference": /\b[A-Z][a-zA-Z0-9]*(?:\.[a-zA-Z][a-zA-Z0-9]*){1,}\b/,
    // ── 6. Event keys: UPPER_SNAKE_CASE (≥ 2 uppercase chars) ────────────────
    // Must come before general keywords to prevent `OPEN` matching `open`.
    // Author-written events stay UPPER_SNAKE in every language (they are
    // identifiers); only the reserved ones are translated.
    "lolo-event": unicodeBoundaryRegExp(`[A-Z][A-Z0-9_]+|${wordsToPattern(reservedEventWords)}`),
    // ── 7. Declaration keywords ──────────────────────────────────────────────
    // Structural keywords that introduce new declarations.
    // Analogous to Haskell's module/import/where/let/in/do/data/type.
    "keyword": wordsToUnicodePattern(multilingualWords(tokens_default.loloKeywords)),
    // ── 8. Effect operators ──────────────────────────────────────────────────
    // Semantic IO primitives: set, persist, fetch, emit, render-ui, navigate …
    // Appear as the first token inside a Lisp s-expression: (persist create …)
    // The hyphen-safe boundary handles `render-ui` and `call-service`.
    ...effectList.length > 0 ? { "lolo-effect": wordsToUnicodePattern(effectList) } : {},
    // ── 9. Runtime operators by namespace ────────────────────────────────────
    // Each namespace gets its own token class so themes can apply different
    // colours (arithmetic=blue, comparison=orange, logic=purple, …).
    ...opTokens,
    // ── 10. Unregistered namespaced operators ────────────────────────────────
    // foo/bar form not found in registry → error colour.
    "lolo-unknown-op": unknownOpPattern,
    // ── 11. Primitive types ──────────────────────────────────────────────────
    // Like Haskell's Int, Bool, String. Orange to match .orb fieldType.
    "lolo-type": wordsToUnicodePattern(multilingualWords(tokens_default.loloPrimitiveTypes)),
    // ── 12. Persistence and scope keywords ───────────────────────────────────
    // Appear in [persistence: collection] tags and emitsScope / listens blocks.
    "lolo-persistence": wordsToUnicodePattern(multilingualWords(tokens_default.loloPersistenceAndScope)),
    // ── 13. Trait category tags ───────────────────────────────────────────────
    // The [category] marker after the entity name in a trait declaration.
    // These map to TraitCategory enum values.
    "lolo-category": wordsToUnicodePattern(multilingualWords(tokens_default.loloTraitCategories)),
    // ── 14. Constructor names ─────────────────────────────────────────────────
    // PascalCase identifiers: entity names, trait names, orbital names.
    // Like Haskell data constructors and type names. Teal to distinguish from
    // declaration keywords (blue) and type primitives (orange).
    "lolo-constructor": unicodeBoundaryRegExp(`[A-Z][a-zA-Z0-9]*|${wordsToPattern(nativeShapeWords)}`),
    // ── 15. Transition / function arrow ──────────────────────────────────────
    // `->` and `→` are the transition arrow in state machines and the
    // entity-binding arrow in trait declarations. Pink, like Haskell `->`.
    "lolo-arrow": /->|→|=/,
    // ── 16. Number literals ───────────────────────────────────────────────────
    "number": /-?(?:\d+\.?\d*)\b/,
    // ── 17. Boolean literals ──────────────────────────────────────────────────
    "boolean": wordsToUnicodePattern(multilingualWords(["true", "false"])),
    // ── 18. Null ──────────────────────────────────────────────────────────────
    "null": wordsToUnicodePattern(multilingualWords(["null"])),
    // ── 19. Type modifiers and relation markers ───────────────────────────────
    // `!` = required, `*` = relation-many, `+` = relation-non-empty
    // These suffix type expressions: `string!`, `CartItem*`, `T+`
    "lolo-modifier": /[!*+](?=\s|$|,|\)|\]|\{)/,
    // ── 20. Punctuation ───────────────────────────────────────────────────────
    "punctuation": /[{}()[\]:,|]/
  };
}
function registerLoloLanguage(Prism) {
  const languages = Prism.languages;
  languages.lolo = buildLoloGrammar();
}
function classifyLoloToken(token) {
  if (/^[@?][\p{L}_][\p{L}\p{N}_.]*$/u.test(token)) return "binding";
  if (/^[A-Z][a-zA-Z0-9]*(?:\.[a-zA-Z][a-zA-Z0-9]*){1,}$/.test(token)) return "reference";
  if (/^[A-Z][A-Z0-9_]+$/.test(token)) return "event";
  if (wordsToAnchoredPattern(reservedEventWords).test(token)) return "event";
  if (wordsToAnchoredPattern(multilingualWords(tokens_default.loloKeywords)).test(token)) return "keyword";
  if (wordsToAnchoredPattern(effectList).test(token)) return "effect";
  for (const [ns, ops] of Object.entries(operatorNamespaces)) {
    if (wordsToAnchoredPattern(ops).test(token)) return `op-${ns}`;
  }
  if (wordsToAnchoredPattern(multilingualWords(tokens_default.loloPrimitiveTypes)).test(token)) return "type";
  if (wordsToAnchoredPattern(multilingualWords(tokens_default.loloPersistenceAndScope)).test(token)) return "persistence";
  if (wordsToAnchoredPattern(multilingualWords(tokens_default.loloTraitCategories)).test(token)) return "category";
  if (/^[A-Z][a-zA-Z0-9]*$/.test(token)) return "constructor";
  if (wordsToAnchoredPattern(nativeShapeWords).test(token)) return "constructor";
  if (patternNamesPattern2?.test(token)) return "pattern";
  if (behaviorNamesPattern?.test(token)) return "behavior";
  return "identifier";
}

// src/lolo/refractor-lolo.ts
function loloLanguage(Prism) {
  registerLoloLanguage(Prism);
}
loloLanguage.displayName = "lolo";
loloLanguage.aliases = [];

// src/colors.ts
var ORB_COLORS = {
  dark: {
    // ── Shared: .orb and .lolo ──────────────────────────────────────────────
    binding: "#22D3EE",
    // cyan  - AvlBindingRef  (@field, ?field)
    effect: "#A78BFA",
    // violet - AvlEffect      (set persist emit …)
    arithmetic: "#4A90D9",
    // blue  - AVL arithmetic
    comparison: "#E8913A",
    // orange - AVL comparison
    logic: "#9B59B6",
    // purple - AVL logic
    control: "#E74C3C",
    // red   - AVL control
    string: "#27AE60",
    // green - AVL string ops
    collection: "#1ABC9C",
    // teal  - AVL collection
    time: "#F39C12",
    // amber - AVL time
    async: "#E91E8F",
    // pink  - AVL async
    event: "#FBBF24",
    // yellow - AvlEvent      (UPPER_SNAKE)
    pattern: "#F472B6",
    // pink  - UI pattern name
    patternWarning: "#F59E0B",
    // amber - unregistered pattern
    error: "#EF4444",
    // red   - unknown/invalid operator
    structural: "#9CA3AF",
    // gray  - .orb schema keys
    stringLiteral: "#4ADE80",
    // green - AvlLiteral
    number: "#60A5FA",
    // blue  - AvlLiteral
    boolean: "#C084FC",
    // purple
    null: "#6B7280",
    // gray
    uiSlot: "#2DD4BF",
    // teal  - AvlSlotMap
    fieldType: "#E8913A",
    // orange - AvlFieldType
    persistence: "#E8913A",
    // orange - Entity stroke
    behavior: "#818CF8",
    // indigo - std behavior name
    // ── LOLO-specific ───────────────────────────────────────────────────────
    loloKeyword: "#569CD6",
    // steel blue  - declaration keywords
    loloConstructor: "#4EC9B0",
    // teal        - PascalCase names
    loloArrow: "#C586C0",
    // soft pink   - `->` / `→`
    loloReference: "#79B8FF"
    // light blue  - Modal.traits.X paths
  },
  light: {
    // ── Shared ──────────────────────────────────────────────────────────────
    binding: "#0891B2",
    effect: "#7C3AED",
    arithmetic: "#2563EB",
    comparison: "#D97706",
    logic: "#7C3AED",
    control: "#DC2626",
    string: "#059669",
    collection: "#0D9488",
    time: "#D97706",
    async: "#DB2777",
    event: "#B45309",
    pattern: "#DB2777",
    patternWarning: "#D97706",
    error: "#DC2626",
    structural: "#6B7280",
    stringLiteral: "#059669",
    number: "#2563EB",
    boolean: "#7C3AED",
    null: "#6B7280",
    uiSlot: "#0D9488",
    fieldType: "#D97706",
    persistence: "#D97706",
    behavior: "#4F46E5",
    // ── LOLO-specific ───────────────────────────────────────────────────────
    loloKeyword: "#0000FF",
    // VS Code light keyword blue
    loloConstructor: "#267F99",
    // VS Code light type teal
    loloArrow: "#AF00DB",
    // VS Code light function arrow purple
    loloReference: "#001080"
    // VS Code light module reference
  }
};

export { NATIVE_LANGUAGES, ORB_COLORS, classifyLoloToken, classifyOrbToken, isRegisteredOperator, isRegisteredPattern, loloLanguage, multilingualOrbKeys, multilingualWords, nativeShapeWords, nativeWords, orbLanguage, registerLoloLanguage, registerOrbLanguage, reservedEventWords, stdOperatorTables, translateLolo, translateOrb };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map